import React from 'react';
export const UserIcon = props => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 24 24">
      <path d="M12,12A4,4,0,1,0,8,8,4,4,0,0,0,12,12Zm0,2c-2.67,0-8,1.34-8,4v2H20V18C20,15.34,14.67,14,12,14Z" />
      <path fill="none" d="M0,0H24V24H0Z" />
    </svg>
  );
};

export const VerifiedIcon = props => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 24 24">
      <path d="M23,12a1,1,0,0,0-.28-.7l-1.15-1.19a1,1,0,0,0-.72-.3,1,1,0,0,0-1,1,1,1,0,0,0,.28.69l.48.5-.69.72a4,4,0,0,0-1.14,2.78,3.43,3.43,0,0,0,0,.56l.14,1-1,.17a4,4,0,0,0-2.85,2.07l-.47.88-.91-.44a3.94,3.94,0,0,0-1.75-.4,4.15,4.15,0,0,0-1.76.4l-.9.44-.47-.88A4,4,0,0,0,6,17.23l-1-.17.14-1a3.39,3.39,0,0,0,0-.55,4,4,0,0,0-1.13-2.78L3.39,12l.69-.72A4,4,0,0,0,5.22,8.5a3.43,3.43,0,0,0,0-.56L5,6.94l1-.17A4,4,0,0,0,8.87,4.7l.47-.88.91.44a3.94,3.94,0,0,0,1.75.4,4.15,4.15,0,0,0,1.76-.4l.9-.44.46.86a1,1,0,0,0,1.93-.39,1,1,0,0,0-.18-.57L16,2a1,1,0,0,0-.88-.53,1,1,0,0,0-.44.1l-1.76.87a2.14,2.14,0,0,1-.89.2,2.06,2.06,0,0,1-.88-.2L9.35,1.59A1,1,0,0,0,8,2L7.11,3.76a2,2,0,0,1-1.43,1l-1.94.34a1,1,0,0,0-.83,1,.66.66,0,0,0,0,.14l.28,2a2.64,2.64,0,0,1,0,.28,2,2,0,0,1-.57,1.39L1.28,11.31a1,1,0,0,0,0,1.38l1.38,1.43a2,2,0,0,1,.56,1.38,2.64,2.64,0,0,1,0,.28l-.28,2a.66.66,0,0,0,0,.14,1,1,0,0,0,.83,1l1.94.34a2,2,0,0,1,1.43,1L8,22a1,1,0,0,0,1.32.43l1.76-.87a2.14,2.14,0,0,1,.89-.2,2.06,2.06,0,0,1,.88.2l1.77.87a1,1,0,0,0,.44.1A1,1,0,0,0,16,22l.92-1.74a2,2,0,0,1,1.43-1l1.94-.34a1,1,0,0,0,.83-1,.66.66,0,0,0,0-.14l-.28-2a2.64,2.64,0,0,1,0-.28,2,2,0,0,1,.57-1.39l1.37-1.42A1,1,0,0,0,23,12ZM9.71,10.29A1,1,0,0,0,9,10a1,1,0,0,0-1,1,1,1,0,0,0,.29.71L12,15.41l9.71-9.7A1,1,0,0,0,22,5a1,1,0,0,0-1-1,1,1,0,0,0-.71.29L12,12.59Z"></path>
    </svg>
  );
};

export const FullScreenIcon = props => {
  return (
    <svg width="14" height="14" {...props}  viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 9H0V14H5V12H2V9ZM0 5H2V2H5V0H0V5ZM12 12H9V14H14V9H12V12ZM9 0V2H12V5H14V0H9Z" fill="white"/>
    </svg>
  );
};

export const ExitFullScreenIcon = props => {
  return (
    <svg width="14" height="14" {...props} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 11H3V14H5V9H0V11ZM3 3H0V5H5V0H3V3ZM9 14H11V11H14V9H9V14ZM11 3V0H9V5H14V3H11Z" fill="white"/>
    </svg>
  );
};

export const RedWarningIcon = props =>{
  return(
  <svg  {...props}  width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M2.47012 18.0001H17.5301C19.0701 18.0001 20.0301 16.3301 19.2601 15.0001L11.7301 1.99005C10.9601 0.660054 9.04012 0.660054 8.27012 1.99005L0.740121 15.0001C-0.0298788 16.3301 0.930121 18.0001 2.47012 18.0001ZM10.0001 11.0001C9.45012 11.0001 9.00012 10.5501 9.00012 10.0001V8.00005C9.00012 7.45005 9.45012 7.00005 10.0001 7.00005C10.5501 7.00005 11.0001 7.45005 11.0001 8.00005V10.0001C11.0001 10.5501 10.5501 11.0001 10.0001 11.0001ZM11.0001 15.0001H9.00012V13.0001H11.0001V15.0001Z" fill="#FF355A"/>
  </svg>
  
  );
  };
export const GeryWarningIcon = props => {
  return(
    <svg {...props} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.47012 20.9999H19.5301C21.0701 20.9999 22.0301 19.3299 21.2601 17.9999L13.7301 4.98993C12.9601 3.65993 11.0401 3.65993 10.2701 4.98993L2.74012 17.9999C1.97012 19.3299 2.93012 20.9999 4.47012 20.9999ZM12.0001 13.9999C11.4501 13.9999 11.0001 13.5499 11.0001 12.9999V10.9999C11.0001 10.4499 11.4501 9.99993 12.0001 9.99993C12.5501 9.99993 13.0001 10.4499 13.0001 10.9999V12.9999C13.0001 13.5499 12.5501 13.9999 12.0001 13.9999ZM13.0001 17.9999H11.0001V15.9999H13.0001V17.9999Z" fill="#A6ABC9"/>
</svg>

  )
} 

  export const BigXCloseBtn = props =>{
    return(
  <svg  {...props}  width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" fill="#363E4A" fill-opacity="0.3"/>
  <path d="M23.59 15L20 18.59L16.41 15L15 16.41L18.59 20L15 23.59L16.41 25L20 21.41L23.59 25L25 23.59L21.41 20L25 16.41L23.59 15Z" fill="white"/>
  <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" stroke="white"/>
  </svg>
  
  
  );
  };
  

export const CheckIcon = props => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 16 16">
      <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z"></path>
    </svg>
  );
};
export const WalletIcon = props => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0  13.868 13.138">
      <path
        d="M17.638,15.449v.73a1.464,1.464,0,0,1-1.46,1.46H5.96a1.459,1.459,0,0,1-1.46-1.46V5.96A1.459,1.459,0,0,1,5.96,4.5H16.178a1.464,1.464,0,0,1,1.46,1.46v.73H11.069a1.459,1.459,0,0,0-1.46,1.46v5.839a1.459,1.459,0,0,0,1.46,1.46Zm-6.569-1.46h7.3V8.15h-7.3Zm2.92-1.825a1.095,1.095,0,1,1,1.095-1.095A1.093,1.093,0,0,1,13.989,12.164Z"
        transform="translate(-4.5 -4.5)"
      />
    </svg>
  );
};
export const CoinsIcon = props => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0  14.12 14.12">
      <path d="M0,11.178v1.178c0,.974,2.372,1.765,5.3,1.765s5.3-.792,5.3-1.765V11.178a10.029,10.029,0,0,1-5.3,1.178A10.029,10.029,0,0,1,0,11.178ZM8.825,3.53c2.923,0,5.3-.792,5.3-1.765S11.749,0,8.825,0s-5.3.792-5.3,1.765S5.9,3.53,8.825,3.53ZM0,8.285V9.708c0,.974,2.372,1.765,5.3,1.765s5.3-.792,5.3-1.765V8.285A8.881,8.881,0,0,1,5.3,9.708,8.881,8.881,0,0,1,0,8.285Zm11.473.3c1.58-.306,2.648-.874,2.648-1.528V5.883a6.773,6.773,0,0,1-2.648.951ZM5.3,4.413C2.372,4.413,0,5.4,0,6.619S2.372,8.825,5.3,8.825s5.3-.987,5.3-2.206S8.218,4.413,5.3,4.413Zm6.048,1.553c1.655-.3,2.777-.883,2.777-1.553V3.235A8.978,8.978,0,0,1,9.688,4.388,3.088,3.088,0,0,1,11.343,5.965Z" />
    </svg>
  );
};
export const FilterIcon = props => {
  return (
    <svg width="22" {...props} height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7 4C5.34315 4 4 5.34315 4 7C4 8.65685 5.34315 10 7 10C8.65685 10 10 8.65685 10 7C10 5.34315 8.65685 4 7 4ZM6 7C6 6.44772 6.44772 6 7 6C7.55228 6 8 6.44772 8 7C8 7.55228 7.55228 8 7 8C6.44772 8 6 7.55228 6 7Z"
        fill="#797F92"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1 0C0.447715 0 0 0.447715 0 1V10C0 10.2652 0.105357 10.5196 0.292894 10.7071L9.87868 20.2929C11.0503 21.4645 12.9497 21.4645 14.1213 20.2929L20.2929 14.1213C21.4645 12.9497 21.4645 11.0503 20.2929 9.87868L10.7071 0.292893C10.5196 0.105357 10.2652 0 10 0H1ZM2 9.58581V2H9.58579L18.8787 11.2929C19.2692 11.6834 19.2692 12.3166 18.8787 12.7071L12.7071 18.8787C12.3166 19.2692 11.6834 19.2692 11.2929 18.8787L2 9.58581Z"
        fill="#797F92"
      />
    </svg>
  );
};




export const RefreshIcon = props => {
  return (
    <svg width="16" height="22" viewBox="0 0 16 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8 3V0L4 4L8 8V5C11.31 5 14 7.69 14 11C14 12.01 13.75 12.97 13.3 13.8L14.76 15.26C15.54 14.03 16 12.57 16 11C16 6.58 12.42 3 8 3ZM8 17C4.69 17 2 14.31 2 11C2 9.99 2.25 9.03 2.7 8.2L1.24 6.74C0.46 7.97 0 9.43 0 11C0 15.42 3.58 19 8 19V22L12 18L8 14V17Z"
        fill="#797F92"
      />
    </svg>
  );
};
export const VerifyIcon = props => {
  return (
     <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.87506 9.16038L10.0973 11.3826L16.4608 5.625"
        stroke="#E7EAF3"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.1524 8.50167L18.4298 9.7465C18.5107 9.82118 18.576 9.91115 18.6219 10.0112C18.6679 10.1113 18.6935 10.2194 18.6974 10.3295C18.7013 10.4395 18.6833 10.5492 18.6445 10.6523C18.6057 10.7553 18.5469 10.8496 18.4715 10.9298L16.5132 12.8798V15.6382C16.5132 15.8592 16.4254 16.0711 16.2691 16.2274C16.1128 16.3837 15.9008 16.4715 15.6798 16.4715H12.9215L10.9715 18.4298C10.894 18.5079 10.8019 18.5699 10.7003 18.6122C10.5988 18.6545 10.4898 18.6763 10.3798 18.6763C10.2698 18.6763 10.1609 18.6545 10.0594 18.6122C9.9578 18.5699 9.86563 18.5079 9.78817 18.4298L7.83817 16.4715H5.03817C4.81715 16.4715 4.60519 16.3837 4.44891 16.2274C4.29263 16.0711 4.20483 15.8592 4.20483 15.6382V12.8798L2.2465 10.9298C2.16839 10.8524 2.1064 10.7602 2.06409 10.6586C2.02178 10.5571 2 10.4482 2 10.3382C2 10.2282 2.02178 10.1192 2.06409 10.0177C2.1064 9.91613 2.16839 9.82397 2.2465 9.7465L4.20483 7.83817V5.03817C4.20483 4.81715 4.29263 4.60519 4.44891 4.44891C4.60519 4.29263 4.81715 4.20483 5.03817 4.20483H7.83817L9.7465 2.2465C9.82397 2.16839 9.91614 2.1064 10.0177 2.06409C10.1192 2.02178 10.2282 2 10.3382 2C10.4482 2 10.5571 2.02178 10.6586 2.06409C10.7602 2.1064 10.8524 2.16839 10.9298 2.2465L12.8798 4.20483H15.6382C15.7246 4.20483 15.8096 4.21826 15.8905 4.24395C15.8629 4.26654 15.8357 4.29 15.809 4.31431L14.1 5.8715H12.5382C12.4279 5.87104 12.3188 5.84871 12.2173 5.80579C12.1157 5.76288 12.0237 5.70024 11.9465 5.6215L10.3382 4.01316L8.72983 5.6215C8.65265 5.70024 8.56062 5.76288 8.45905 5.80579C8.35749 5.84871 8.24842 5.87104 8.13817 5.8715H5.8715V8.13816C5.87104 8.24842 5.84871 8.35749 5.80579 8.45905C5.76288 8.56062 5.70024 8.65265 5.6215 8.72983L4.01317 10.3382L5.6215 11.9465C5.70024 12.0237 5.76288 12.1157 5.80579 12.2173C5.84871 12.3188 5.87104 12.4279 5.8715 12.5382V14.8048H8.13817C8.24842 14.8053 8.35749 14.8276 8.45905 14.8705C8.56062 14.9134 8.65265 14.9761 8.72983 15.0548L10.3382 16.6632L11.9465 15.0548C12.0237 14.9761 12.1157 14.9134 12.2173 14.8705C12.3188 14.8276 12.4279 14.8053 12.5382 14.8048H14.8048V12.5382C14.8053 12.4279 14.8276 12.3188 14.8705 12.2173C14.9135 12.1157 14.9761 12.0237 15.0548 11.9465L16.6632 10.3382L15.9355 9.61045L17.1524 8.50167Z"
        fill="#E7EAF3"
      />
    </svg>
  );
};
export const Freesub = props => {
  return (
    <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.25 0.75L18.25 17.75L17 19L15 17H3C1.9 17 1 16.1 1 15V5C1 4.45 1.23 3.95 1.59 3.59L0 2L1.25 0.75ZM20 10L15.63 3.84C15.27 3.33 14.67 3 14 3H6L17 14L20 10Z"
        fill="#797F92"
      />
    </svg>
  );
};
export const HelpIcon = props => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0  14.12 14.12">
      <path
        d="M10.435,3.375a7.06,7.06,0,1,0,7.06,7.06A7.059,7.059,0,0,0,10.435,3.375Zm-.146,10.319a.7.7,0,1,1,.73-.7A.709.709,0,0,1,10.289,13.694ZM11.654,10.4c-.591.343-.791.594-.791,1.028V11.7H9.685l-.01-.292a1.413,1.413,0,0,1,.8-1.493c.574-.343.815-.56.815-.981a.824.824,0,0,0-.913-.73.859.859,0,0,0-.91.835h-1.2a1.94,1.94,0,0,1,2.2-1.867c1.273,0,2.149.706,2.149,1.721A1.661,1.661,0,0,1,11.654,10.4Z"
        transform="translate(-3.375 -3.375)"
      />
    </svg>
  );
};
export const EmailIcon = props => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 17.6 14.08">
      <path
        d="M18.84,6H4.76A1.758,1.758,0,0,0,3.009,7.76L3,18.32a1.765,1.765,0,0,0,1.76,1.76H18.84a1.765,1.765,0,0,0,1.76-1.76V7.76A1.765,1.765,0,0,0,18.84,6Zm0,3.52-7.04,4.4L4.76,9.52V7.76l7.04,4.4,7.04-4.4Z"
        transform="translate(-3 -6)"
      />
    </svg>
  );
};
export const PlaneIcon = props => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 35.996 36.007">
      <path
        className="a"
        d="M33.469.225.879,19.027a1.689,1.689,0,0,0,.155,3.038L8.508,25.2l20.2-17.8a.422.422,0,0,1,.6.584L12.375,28.617v5.66a1.687,1.687,0,0,0,2.988,1.111l4.465-5.435,8.761,3.67a1.692,1.692,0,0,0,2.32-1.28L35.972,1.969A1.688,1.688,0,0,0,33.469.225Z"
        transform="translate(-0.001 0.002)"
      />
    </svg>
  );
};

export const SearchIcon = props => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21.7099 20.29L17.9999 16.61C19.44 14.8144 20.1374 12.5353 19.9487 10.2413C19.76 7.9473 18.6996 5.81278 16.9854 4.27664C15.2713 2.7405 13.0337 1.91951 10.7328 1.98247C8.43194 2.04543 6.24263 2.98756 4.61505 4.61514C2.98747 6.24272 2.04534 8.43203 1.98237 10.7329C1.91941 13.0338 2.74041 15.2714 4.27655 16.9855C5.81269 18.6997 7.94721 19.7601 10.2412 19.9488C12.5352 20.1375 14.8143 19.4401 16.6099 18L20.2899 21.68C20.3829 21.7737 20.4935 21.8481 20.6153 21.8989C20.7372 21.9497 20.8679 21.9758 20.9999 21.9758C21.1319 21.9758 21.2626 21.9497 21.3845 21.8989C21.5063 21.8481 21.6169 21.7737 21.7099 21.68C21.8901 21.4935 21.9909 21.2443 21.9909 20.985C21.9909 20.7257 21.8901 20.4765 21.7099 20.29ZM10.9999 18C9.61544 18 8.26206 17.5895 7.11091 16.8203C5.95977 16.0511 5.06256 14.9579 4.53275 13.6788C4.00293 12.3997 3.86431 10.9922 4.13441 9.63436C4.4045 8.2765 5.07119 7.02922 6.05016 6.05025C7.02912 5.07128 8.27641 4.4046 9.63427 4.1345C10.9921 3.8644 12.3996 4.00303 13.6787 4.53284C14.9578 5.06265 16.051 5.95986 16.8202 7.111C17.5894 8.26215 17.9999 9.61553 17.9999 11C17.9999 12.8565 17.2624 14.637 15.9497 15.9497C14.6369 17.2625 12.8564 18 10.9999 18Z"
        fill="#E7EAF3"
      />
    </svg>
  );
};

export const PlusIcon = props => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 36 36">
      <path
        d="M42.724,24.724H29.206V11.206a2.241,2.241,0,1,0-4.482,0V24.724H11.206a2.241,2.241,0,0,0,0,4.482H24.724V42.724a2.241,2.241,0,0,0,4.482,0V29.206H42.724a2.241,2.241,0,0,0,0-4.482Z"
        transform="translate(-8.965 -8.965)"
      />
    </svg>
  );
};
export const SettingIcon = props => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 30.229 30.229">
      <path
        d="M29.968,20a9.452,9.452,0,0,0,.077-1.511c0-.529-.077-.982-.077-1.511l3.246-2.494a.694.694,0,0,0,.155-.982L30.277,8.287a.753.753,0,0,0-.928-.3L25.485,9.5a11.25,11.25,0,0,0-2.628-1.512L22.316,3.98a.828.828,0,0,0-.773-.6H15.359a.828.828,0,0,0-.773.6l-.618,4.005A13.089,13.089,0,0,0,11.339,9.5L7.475,7.985a.724.724,0,0,0-.928.3L3.455,13.5a.913.913,0,0,0,.155.982l3.324,2.494c0,.529-.077.982-.077,1.511s.077.982.077,1.511L3.688,22.495a.694.694,0,0,0-.155.982l3.092,5.215a.753.753,0,0,0,.928.3l3.865-1.512a11.249,11.249,0,0,0,2.628,1.512L14.663,33a.749.749,0,0,0,.773.6H21.62a.828.828,0,0,0,.773-.6l.619-4.005a13.082,13.082,0,0,0,2.628-1.512L29.5,28.994a.724.724,0,0,0,.928-.3l3.092-5.215a.911.911,0,0,0-.155-.982ZM18.451,23.78a5.291,5.291,0,1,1,0-10.58,5.291,5.291,0,1,1,0,10.58Z"
        transform="translate(-3.375 -3.375)"
      />
    </svg>
  );
};
export const ShareIcon = props => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 44.594 39.639">
      <path
        d="M44.012,13.738,32.863,24.266a1.859,1.859,0,0,1-3.134-1.351V17.344c-11.193.075-15.915,2.718-12.757,13.266a1.24,1.24,0,0,1-1.936,1.342,14.9,14.9,0,0,1-5.746-11.1c0-11.144,9.1-13.355,20.439-13.418V1.859A1.859,1.859,0,0,1,32.863.508L44.012,11.036A1.859,1.859,0,0,1,44.012,13.738ZM29.729,29.352v5.332H4.955V9.91H8.9a.928.928,0,0,0,.67-.286,15.093,15.093,0,0,1,3.949-2.917.929.929,0,0,0-.429-1.752H3.716A3.716,3.716,0,0,0,0,8.671V35.923a3.716,3.716,0,0,0,3.716,3.716H30.968a3.716,3.716,0,0,0,3.716-3.716V29.047a.929.929,0,0,0-1.24-.875,5.561,5.561,0,0,1-2.647.261A.931.931,0,0,0,29.729,29.352Z"
        transform="translate(0 0)"
      />
    </svg>
  );
};
export const LanguageArrow = props => {
  return (
    <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 1L5 5L9 1" stroke="#8B95B1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
};
export const ArrowLeftIcon = props => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 38.988 38">
      <path
        d="M22.407,38.1l-1.932,1.932a2.08,2.08,0,0,1-2.95,0L.61,23.127a2.08,2.08,0,0,1,0-2.95L17.526,3.261a2.08,2.08,0,0,1,2.95,0l1.932,1.932a2.091,2.091,0,0,1-.035,2.985L11.887,18.167H36.9a2.083,2.083,0,0,1,2.088,2.088v2.785A2.083,2.083,0,0,1,36.9,25.128H11.887l10.485,9.989A2.076,2.076,0,0,1,22.407,38.1Z"
        transform="translate(0.004 -2.647)"
      />
    </svg>
  );
};
export const Locked = props => {
  return (
    <svg {...props} viewBox="0 0 109.9 144.244">
      <path
        className="a"
        d="M102.163,49.581H95.294V35.844a34.344,34.344,0,0,0-68.688,0V49.581H19.738A13.778,13.778,0,0,0,6,63.319v68.688a13.778,13.778,0,0,0,13.738,13.737h82.425A13.778,13.778,0,0,0,115.9,132.006V63.319A13.778,13.778,0,0,0,102.163,49.581ZM60.95,111.4A13.738,13.738,0,1,1,74.688,97.663,13.778,13.778,0,0,1,60.95,111.4ZM82.243,49.581H39.657V35.844a21.293,21.293,0,1,1,42.586,0Z"
        transform="translate(-6 -1.5)"
      />
    </svg>
  );
};
export const ArrowRightRounded = props => {
  return (
    <svg {...props} viewBox="0 0 24 24" aria-hidden="true" role="presentation">
      <path d="M9.29 6.71c-.39.39-.39 1.02 0 1.41L13.17 12l-3.88 3.88c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0l4.59-4.59c.39-.39.39-1.02 0-1.41L10.7 6.7c-.38-.38-1.02-.38-1.41.01z"></path>
    </svg>
  );
};
export const ArrowLeftRounded = props => {
  return (
    <svg {...props} viewBox="0 0 24 24" aria-hidden="true" role="presentation">
      <path d="M14.71 6.71a.9959.9959 0 00-1.41 0L8.71 11.3c-.39.39-.39 1.02 0 1.41l4.59 4.59c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L10.83 12l3.88-3.88c.39-.39.38-1.03 0-1.41z"></path>
    </svg>
  );
};
export const AddPhotoIcon = props => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 45 41.087">
      <path
        d="M5.87,7.37V1.5H9.783V7.37h5.87v3.913H9.783v5.87H5.87v-5.87H0V7.37Zm5.87,11.739v-5.87h5.87V7.37H31.3l3.58,3.913h6.2A3.925,3.925,0,0,1,45,15.2V38.674a3.925,3.925,0,0,1-3.913,3.913H9.783A3.925,3.925,0,0,1,5.87,38.674V19.109Zm13.7,17.609a9.783,9.783,0,1,0-9.783-9.783A9.786,9.786,0,0,0,25.435,36.717Zm-6.261-9.783a6.261,6.261,0,1,0,6.261-6.261A6.254,6.254,0,0,0,19.174,26.935Z"
        transform="translate(0 -1.5)"
      />
    </svg>
  );
};

export const ChangePhotoIcon = props => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="12" cy="12" r="12" fill="#E7EAF3" />
      <path
        d="M9.88681 6.46004H13.3892C13.5562 6.46004 13.7165 6.5264 13.8346 6.64454C13.9527 6.76267 14.0191 6.92289 14.0191 7.08996C14.0191 7.25702 13.9527 7.41725 13.8346 7.53538C13.7165 7.65351 13.5562 7.71988 13.3892 7.71988H9.91831C9.78625 7.71954 9.65742 7.76071 9.55004 7.83758C9.44265 7.91444 9.36214 8.02311 9.31988 8.14823L9.41462 8.18023M9.88681 6.46004L17.1687 10.2396V10.1396C17.1687 10.1396 17.1686 10.1396 17.1686 10.1396C16.975 10.1396 16.7894 10.2165 16.6526 10.3534C16.5157 10.4902 16.4388 10.6759 16.4388 10.8695V15.2789C16.4388 15.4195 16.3829 15.5543 16.2836 15.6536C16.1842 15.753 16.0494 15.8089 15.9089 15.8089H7.08996C6.94942 15.8089 6.81463 15.753 6.71525 15.6536C6.61587 15.5543 6.56004 15.4195 6.56004 15.2789V10.2396C6.56004 10.099 6.61587 9.96423 6.71525 9.86485C6.81463 9.76547 6.94942 9.70964 7.08996 9.70964H8.34729C8.50554 9.71732 8.66202 9.67329 8.79308 9.58417C8.92488 9.49455 9.02372 9.36424 9.07451 9.21316L9.07471 9.21257L9.41462 8.18023M9.88681 6.46004C9.49093 6.46078 9.10529 6.58582 8.7843 6.81752C8.46331 7.04922 8.22319 7.37587 8.09783 7.75138L9.88681 6.46004ZM9.41462 8.18023C9.41466 8.18011 9.4147 8.17999 9.41474 8.17988M9.41462 8.18023L9.41474 8.17988M9.41474 8.17988C9.45032 8.07477 9.518 7.98348 9.60824 7.91889C9.69858 7.85423 9.80695 7.81959 9.91805 7.81988H9.91831H13.3892C13.5828 7.81988 13.7684 7.74298 13.9053 7.60609C14.0422 7.4692 14.1191 7.28355 14.1191 7.08996C14.1191 6.89637 14.0422 6.71071 13.9053 6.57383C13.7684 6.43694 13.5828 6.36004 13.3892 6.36004L9.88681 6.36004L9.88662 6.36004C9.4698 6.36082 9.06375 6.49248 8.72577 6.73644C8.3878 6.9804 8.13497 7.32434 8.00298 7.71971L8.00297 7.71971L8.00259 7.7209L7.82326 8.2813H7.08996C6.56224 8.2813 6.05614 8.49093 5.68298 8.86409C5.30983 9.23724 5.1002 9.74334 5.1002 10.2711V15.3104C5.1002 15.8381 5.30983 16.3443 5.68298 16.7174C6.05614 17.0906 6.56224 17.3002 7.08996 17.3002H15.9089C16.4366 17.3002 16.9427 17.0906 17.3158 16.7174C17.689 16.3443 17.8986 15.8381 17.8986 15.3104V10.9034C17.9032 10.8054 17.8879 10.7074 17.8538 10.6154L17.76 10.6502L9.41474 8.17988ZM11.4994 9.50964C10.9813 9.50964 10.4748 9.66329 10.044 9.95114C9.61318 10.239 9.27741 10.6481 9.07913 11.1268C8.88086 11.6055 8.82898 12.1322 8.93006 12.6404C9.03114 13.1486 9.28064 13.6154 9.64701 13.9817C10.0134 14.3481 10.4802 14.5976 10.9883 14.6987C11.4965 14.7998 12.0232 14.7479 12.5019 14.5496C12.9806 14.3513 13.3897 14.0156 13.6776 13.5847C13.9655 13.1539 14.1191 12.6475 14.1191 12.1293C14.1191 11.4345 13.8431 10.7682 13.3518 10.2769C12.8605 9.78565 12.1942 9.50964 11.4994 9.50964ZM11.4994 13.2892C11.27 13.2892 11.0458 13.2211 10.855 13.0937C10.6643 12.9663 10.5156 12.7851 10.4279 12.5732C10.3401 12.3612 10.3171 12.128 10.3619 11.9031C10.4066 11.6781 10.5171 11.4714 10.6793 11.3092C10.8415 11.147 11.0481 11.0365 11.2731 10.9918C11.4981 10.947 11.7313 10.97 11.9433 11.0578C12.1552 11.1456 12.3363 11.2942 12.4638 11.485C12.5912 11.6757 12.6593 11.8999 12.6593 12.1293C12.6593 12.4369 12.5371 12.7319 12.3195 12.9495C12.102 13.167 11.807 13.2892 11.4994 13.2892ZM18.4285 6.36004H17.8986V5.83012C17.8986 5.63653 17.8217 5.45087 17.6848 5.31398C17.5479 5.1771 17.3623 5.1002 17.1687 5.1002C16.9751 5.1002 16.7895 5.1771 16.6526 5.31398C16.5157 5.45087 16.4388 5.63653 16.4388 5.83012V6.36004H15.9089C15.7153 6.36004 15.5296 6.43694 15.3927 6.57383C15.2558 6.71071 15.1789 6.89637 15.1789 7.08996C15.1789 7.28355 15.2558 7.4692 15.3927 7.60609C15.5296 7.74298 15.7153 7.81988 15.9089 7.81988H16.4388V8.3498C16.4388 8.54339 16.5157 8.72905 16.6526 8.86593C16.7895 9.00282 16.9751 9.07972 17.1687 9.07972C17.3623 9.07972 17.5479 9.00282 17.6848 8.86593C17.8217 8.72905 17.8986 8.54339 17.8986 8.3498V7.81988H18.4285C18.6221 7.81988 18.8078 7.74298 18.9447 7.60609C19.0816 7.4692 19.1585 7.28355 19.1585 7.08996C19.1585 6.89637 19.0816 6.71071 18.9447 6.57383C18.8078 6.43694 18.6221 6.36004 18.4285 6.36004Z"
        fill="#10161E"
        stroke="#10161E"
        strokeWidth="0.2"
      />
    </svg>
  );
};
export const VideoIcon = props => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 51.31 34.207">
      <path
        d="M29.949,4.5H4.258A4.258,4.258,0,0,0,0,8.758V34.449a4.258,4.258,0,0,0,4.258,4.258H29.949a4.258,4.258,0,0,0,4.258-4.258V8.758A4.258,4.258,0,0,0,29.949,4.5ZM46.82,7.858l-9.763,6.734V28.614L46.82,35.34a2.856,2.856,0,0,0,4.49-2.3V10.157A2.858,2.858,0,0,0,46.82,7.858Z"
        transform="translate(0 -4.5)"
      />
    </svg>
  );
};

export const SmallVideoIcon = props => {
  return (
    <svg {...props} width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 2V10H2V2H12ZM13 0H1C0.45 0 0 0.45 0 1V11C0 11.55 0.45 12 1 12H13C13.55 12 14 11.55 14 11V7.5L18 11.5V0.5L14 4.5V1C14 0.45 13.55 0 13 0Z"
        fill="#A6ABC9"
      />
    </svg>
  );
};

export const SmallImageIcon = props => {
  return (
    <svg {...props} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16 2V16H2V2H16ZM16 0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16V2C18 0.9 17.1 0 16 0ZM11.14 8.86L8.14 12.73L6 10.14L3 14H15L11.14 8.86Z"
        fill="#A6ABC9"
      />
    </svg>
  );
};

export const DolarSIcon = props => {
  return (
    <svg width="12" height="17" viewBox="0 0 12 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.17116 16.6364H6.67969L6.69247 15.1598C9.46023 14.9489 11.0646 13.4787 11.071 11.2607C11.0646 9.08097 9.42188 7.92401 7.14631 7.41264L6.76918 7.32315L6.79474 4.12713C7.64489 4.32528 8.16264 4.86861 8.23935 5.67401H10.892C10.8601 3.55824 9.28125 2.04332 6.82031 1.77486L6.8331 0.272726H5.32457L5.31179 1.76207C2.8125 2.00497 1.0483 3.51349 1.06108 5.69318C1.05469 7.62358 2.41619 8.7294 4.62784 9.25994L5.24148 9.41335L5.20952 12.7947C4.16761 12.5966 3.46449 11.9574 3.39418 10.8899H0.715909C0.77983 13.4723 2.47372 14.9169 5.18395 15.1534L5.17116 16.6364ZM6.71804 12.7947L6.74361 9.80966C7.73438 10.1229 8.27131 10.5256 8.2777 11.2543C8.27131 12.0277 7.68324 12.603 6.71804 12.7947ZM5.26065 6.93324C4.46165 6.65838 3.88636 6.2429 3.89915 5.50781C3.89915 4.82386 4.38494 4.29332 5.28622 4.10795L5.26065 6.93324Z"
        fill="#E7EAF3"
      />
    </svg>
  );
};
export const PostHeartIcon = ({ props, fill = '#E7EAF3' }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
        d="M19.4069 5.41452C18.9726 4.96607 18.4568 4.61034 17.8891 4.36763C17.3215 4.12492 16.713 4 16.0986 4C15.4841 4 14.8757 4.12492 14.308 4.36763C13.7403 4.61034 13.2246 4.96607 12.7902 5.41452L11.8887 6.34476L10.9871 5.41452C10.1097 4.50912 8.91965 4.00047 7.67876 4.00047C6.43788 4.00047 5.24782 4.50912 4.37038 5.41452C3.49294 6.31992 3 7.5479 3 8.82833C3 10.1088 3.49294 11.3367 4.37038 12.2421L5.27189 13.1724L11.8887 20L18.5054 13.1724L19.4069 12.2421C19.8415 11.7939 20.1863 11.2617 20.4215 10.676C20.6567 10.0902 20.7778 9.46237 20.7778 8.82833C20.7778 8.19428 20.6567 7.56645 20.4215 6.9807C20.1863 6.39494 19.8415 5.86275 19.4069 5.41452Z"
        stroke="#A6ABC9"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const HeartIcon = ({ props, fill = '#E7EAF3' }) => {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M17.1543 7.88407C16.8828 7.6038 16.5605 7.38146 16.2057 7.22977C15.8509 7.07808 15.4706 7 15.0866 7C14.7026 7 14.3223 7.07808 13.9675 7.22977C13.6127 7.38146 13.2903 7.6038 13.0189 7.88407L12.4554 8.46547L11.892 7.88407C11.3436 7.3182 10.5998 7.00029 9.82422 7.00029C9.04867 7.00029 8.30488 7.3182 7.75648 7.88407C7.20808 8.44995 6.89999 9.21744 6.89999 10.0177C6.89999 10.818 7.20808 11.5855 7.75648 12.1513L8.31993 12.7327L12.4554 17L16.5909 12.7327L17.1543 12.1513C17.426 11.8712 17.6414 11.5386 17.7884 11.1725C17.9354 10.8064 18.0111 10.414 18.0111 10.0177C18.0111 9.62143 17.9354 9.22903 17.7884 8.86294C17.6414 8.49684 17.426 8.16422 17.1543 7.88407Z"  stroke="#A6ABC9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  );
};

export const PostHeartIconFilled = props => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
     <path
        d="M19.4069 5.41452C18.9726 4.96607 18.4568 4.61034 17.8891 4.36763C17.3215 4.12492 16.713 4 16.0986 4C15.4841 4 14.8757 4.12492 14.308 4.36763C13.7403 4.61034 13.2246 4.96607 12.7902 5.41452L11.8887 6.34476L10.9871 5.41452C10.1097 4.50912 8.91965 4.00047 7.67876 4.00047C6.43788 4.00047 5.24782 4.50912 4.37038 5.41452C3.49294 6.31992 3 7.5479 3 8.82833C3 10.1088 3.49294 11.3367 4.37038 12.2421L5.27189 13.1724L11.8887 20L18.5054 13.1724L19.4069 12.2421C19.8415 11.7939 20.1863 11.2617 20.4215 10.676C20.6567 10.0902 20.7778 9.46237 20.7778 8.82833C20.7778 8.19428 20.6567 7.56645 20.4215 6.9807C20.1863 6.39494 19.8415 5.86275 19.4069 5.41452Z"
        fill="#FF355A"
        stroke="#FF355A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
    
  );
};
export const HeartIconFilled = props => {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M17.1543 7.88407C16.8828 7.6038 16.5605 7.38146 16.2057 7.22977C15.8509 7.07808 15.4706 7 15.0866 7C14.7026 7 14.3223 7.07808 13.9675 7.22977C13.6127 7.38146 13.2903 7.6038 13.0189 7.88407L12.4554 8.46547L11.892 7.88407C11.3436 7.3182 10.5998 7.00029 9.82422 7.00029C9.04867 7.00029 8.30488 7.3182 7.75648 7.88407C7.20808 8.44995 6.89999 9.21744 6.89999 10.0177C6.89999 10.818 7.20808 11.5855 7.75648 12.1513L8.31993 12.7327L12.4554 17L16.5909 12.7327L17.1543 12.1513C17.426 11.8712 17.6414 11.5386 17.7884 11.1725C17.9354 10.8064 18.0111 10.414 18.0111 10.0177C18.0111 9.62143 17.9354 9.22903 17.7884 8.86294C17.6414 8.49684 17.426 8.16422 17.1543 7.88407Z" fill="#FF355A" stroke="#FF355A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    
  );
};

export const CommentIcon = props => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 24.158 22.001">
      <path
        d="M28.658,14.889a9.5,9.5,0,0,1-1.208,4.645,11.57,11.57,0,0,1-10.2,5.745,12.156,12.156,0,0,1-5.1-1.1L4.5,26.5l2.55-6.967a9.5,9.5,0,0,1-1.208-4.645A10.337,10.337,0,0,1,12.15,5.6a12.156,12.156,0,0,1,5.1-1.1h.671c5.792.291,10.417,4.5,10.737,9.778Z"
        transform="translate(-4.5 -4.5)"
      />
    </svg>
  );
};
export const CommentDolarIcon = props => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 40.5 31.5">
      <path
        d="M29.25,13.5c0-6.214-6.548-11.25-14.625-11.25S0,7.286,0,13.5a9.548,9.548,0,0,0,2.67,6.467A15.739,15.739,0,0,1,.155,23.8a.562.562,0,0,0,.408.949A12.372,12.372,0,0,0,6.8,22.994a17.847,17.847,0,0,0,7.824,1.756C22.7,24.75,29.25,19.714,29.25,13.5ZM13.5,20.25V19.1a4.026,4.026,0,0,1-2.206-.8.563.563,0,0,1-.04-.854l.826-.788a.577.577,0,0,1,.712-.051,1.693,1.693,0,0,0,.9.262h1.976a.884.884,0,0,0,.83-.927.918.918,0,0,0-.617-.9L12.72,14.1a3.182,3.182,0,0,1-2.22-3.051,3.131,3.131,0,0,1,3-3.169V6.75a.562.562,0,0,1,.563-.562h1.125a.562.562,0,0,1,.563.563V7.9a4.021,4.021,0,0,1,2.206.8.563.563,0,0,1,.04.854l-.826.788a.577.577,0,0,1-.712.051,1.687,1.687,0,0,0-.9-.262H13.579a.884.884,0,0,0-.83.927.918.918,0,0,0,.617.9l3.164.949a3.182,3.182,0,0,1,2.22,3.051,3.131,3.131,0,0,1-3,3.169V20.25a.562.562,0,0,1-.562.563H14.063A.562.562,0,0,1,13.5,20.25Zm24.329,8.718A9.544,9.544,0,0,0,40.5,22.5c0-4.707-3.761-8.733-9.094-10.411A10.91,10.91,0,0,1,31.5,13.5c0,7.444-7.57,13.5-16.875,13.5a20.97,20.97,0,0,1-2.231-.132c2.217,4.044,7.418,6.882,13.481,6.882A17.847,17.847,0,0,0,33.7,31.994a12.372,12.372,0,0,0,6.239,1.756.562.562,0,0,0,.407-.95A15.678,15.678,0,0,1,37.829,28.968Z"
        transform="translate(0 -2.25)"
      />
    </svg>
  );
};
export const CommentDotsIcon = ({ props, fill = '#E7EAF3' }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="path-1-inside-1" fill="white">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.0001 21C16.9707 21 21.0001 16.9706 21.0001 12C21.0001 7.02944 16.9707 3 12.0001 3C7.02954 3 3.0001 7.02944 3.0001 12C3.0001 13.2212 3.24332 14.3855 3.68395 15.4473L2.36816 18.9466C2.09633 19.6695 2.71171 20.4145 3.47294 20.2842L7.23947 19.6393C8.6204 20.5016 10.2521 21 12.0001 21Z"
        />
      </mask>
      <path
        d="M3.68395 15.4473L5.08797 15.9752L5.29671 15.4201L5.06938 14.8724L3.68395 15.4473ZM2.36816 18.9466L3.77218 19.4745L3.77218 19.4745L2.36816 18.9466ZM3.47294 20.2842L3.7261 21.7627L3.7261 21.7627L3.47294 20.2842ZM7.23947 19.6393L8.03401 18.367L7.54943 18.0644L6.98632 18.1608L7.23947 19.6393ZM19.5001 12C19.5001 16.1421 16.1422 19.5 12.0001 19.5V22.5C17.7991 22.5 22.5001 17.799 22.5001 12H19.5001ZM12.0001 4.5C16.1422 4.5 19.5001 7.85786 19.5001 12H22.5001C22.5001 6.20101 17.7991 1.5 12.0001 1.5V4.5ZM4.5001 12C4.5001 7.85786 7.85797 4.5 12.0001 4.5V1.5C6.20111 1.5 1.5001 6.20101 1.5001 12H4.5001ZM5.06938 14.8724C4.70305 13.9896 4.5001 13.0204 4.5001 12H1.5001C1.5001 13.4219 1.78358 14.7814 2.29851 16.0223L5.06938 14.8724ZM3.77218 19.4745L5.08797 15.9752L2.27992 14.9194L0.964133 18.4186L3.77218 19.4745ZM3.21979 18.8057C3.6004 18.7405 3.90809 19.1131 3.77218 19.4745L0.964133 18.4186C0.284574 20.2259 1.82302 22.0885 3.7261 21.7627L3.21979 18.8057ZM6.98632 18.1608L3.21979 18.8057L3.7261 21.7627L7.49263 21.1177L6.98632 18.1608ZM12.0001 19.5C10.5411 19.5 9.18359 19.0849 8.03401 18.367L6.44493 20.9115C8.05721 21.9184 9.96303 22.5 12.0001 22.5V19.5Z"
        fill="#A6ABC9"
        mask="url(#path-1-inside-1)"
      />
    </svg>
  );
};
export const DisabledCommentDotsIcon = ({ props, fill = '#E7EAF3' }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="path-1-inside-1" fill="white">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.0001 21C16.9707 21 21.0001 16.9706 21.0001 12C21.0001 7.02944 16.9707 3 12.0001 3C7.02954 3 3.0001 7.02944 3.0001 12C3.0001 13.2212 3.24332 14.3855 3.68395 15.4473L2.36816 18.9466C2.09633 19.6695 2.71171 20.4145 3.47294 20.2842L7.23947 19.6393C8.6204 20.5016 10.2521 21 12.0001 21Z"
        />
      </mask>
      <path
        d="M3.68395 15.4473L5.08797 15.9752L5.29671 15.4201L5.06938 14.8724L3.68395 15.4473ZM2.36816 18.9466L3.77218 19.4745L3.77218 19.4745L2.36816 18.9466ZM3.47294 20.2842L3.7261 21.7627L3.7261 21.7627L3.47294 20.2842ZM7.23947 19.6393L8.03401 18.367L7.54943 18.0644L6.98632 18.1608L7.23947 19.6393ZM19.5001 12C19.5001 16.1421 16.1422 19.5 12.0001 19.5V22.5C17.7991 22.5 22.5001 17.799 22.5001 12H19.5001ZM12.0001 4.5C16.1422 4.5 19.5001 7.85786 19.5001 12H22.5001C22.5001 6.20101 17.7991 1.5 12.0001 1.5V4.5ZM4.5001 12C4.5001 7.85786 7.85797 4.5 12.0001 4.5V1.5C6.20111 1.5 1.5001 6.20101 1.5001 12H4.5001ZM5.06938 14.8724C4.70305 13.9896 4.5001 13.0204 4.5001 12H1.5001C1.5001 13.4219 1.78358 14.7814 2.29851 16.0223L5.06938 14.8724ZM3.77218 19.4745L5.08797 15.9752L2.27992 14.9194L0.964133 18.4186L3.77218 19.4745ZM3.21979 18.8057C3.6004 18.7405 3.90809 19.1131 3.77218 19.4745L0.964133 18.4186C0.284574 20.2259 1.82302 22.0885 3.7261 21.7627L3.21979 18.8057ZM6.98632 18.1608L3.21979 18.8057L3.7261 21.7627L7.49263 21.1177L6.98632 18.1608ZM12.0001 19.5C10.5411 19.5 9.18359 19.0849 8.03401 18.367L6.44493 20.9115C8.05721 21.9184 9.96303 22.5 12.0001 22.5V19.5Z"
        fill="#565C71"
        mask="url(#path-1-inside-1)"
      />
    </svg>
  );
};

export const CommentIconFilled = props => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <mask id="path-1-inside-1" fill="white">
        <path
          fillRule="evenodd"
          clip-rule="evenodd"
          d="M12.0001 21C16.9707 21 21.0001 16.9706 21.0001 12C21.0001 7.02944 16.9707 3 12.0001 3C7.02954 3 3.0001 7.02944 3.0001 12C3.0001 13.2212 3.24332 14.3855 3.68395 15.4473L2.36816 18.9466C2.09633 19.6695 2.71171 20.4145 3.47294 20.2842L7.23947 19.6393C8.6204 20.5016 10.2521 21 12.0001 21Z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0001 21C16.9707 21 21.0001 16.9706 21.0001 12C21.0001 7.02944 16.9707 3 12.0001 3C7.02954 3 3.0001 7.02944 3.0001 12C3.0001 13.2212 3.24332 14.3855 3.68395 15.4473L2.36816 18.9466C2.09633 19.6695 2.71171 20.4145 3.47294 20.2842L7.23947 19.6393C8.6204 20.5016 10.2521 21 12.0001 21Z"
        fill="#E7EAF3"
      />
      <path
        d="M3.68395 15.4473L5.08797 15.9752L5.29671 15.4201L5.06938 14.8724L3.68395 15.4473ZM2.36816 18.9466L3.77218 19.4745H3.77218L2.36816 18.9466ZM3.47294 20.2842L3.7261 21.7627H3.7261L3.47294 20.2842ZM7.23947 19.6393L8.03401 18.367L7.54943 18.0644L6.98632 18.1608L7.23947 19.6393ZM19.5001 12C19.5001 16.1421 16.1422 19.5 12.0001 19.5V22.5C17.7991 22.5 22.5001 17.799 22.5001 12H19.5001ZM12.0001 4.5C16.1422 4.5 19.5001 7.85786 19.5001 12H22.5001C22.5001 6.20101 17.7991 1.5 12.0001 1.5V4.5ZM4.5001 12C4.5001 7.85786 7.85797 4.5 12.0001 4.5V1.5C6.20111 1.5 1.5001 6.20101 1.5001 12H4.5001ZM5.06938 14.8724C4.70305 13.9896 4.5001 13.0204 4.5001 12H1.5001C1.5001 13.4219 1.78358 14.7814 2.29851 16.0223L5.06938 14.8724ZM3.77218 19.4745L5.08797 15.9752L2.27992 14.9194L0.964133 18.4186L3.77218 19.4745ZM3.21979 18.8057C3.6004 18.7405 3.90809 19.1131 3.77218 19.4745L0.964133 18.4186C0.284574 20.2259 1.82302 22.0885 3.7261 21.7627L3.21979 18.8057ZM6.98632 18.1608L3.21979 18.8057L3.7261 21.7627L7.49263 21.1177L6.98632 18.1608ZM12.0001 19.5C10.5411 19.5 9.18359 19.0849 8.03401 18.367L6.44493 20.9115C8.05721 21.9184 9.96303 22.5 12.0001 22.5V19.5Z"
        fill="#E7EAF3"
        mask="url(#path-1-inside-1)"
      />
    </svg>
  );
};

export const BookmarkIcon = props => {
  return (
    <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M12 0H2C0.9 0 0.0100002 0.9 0.0100002 2L0 18L7 15L14 18V2C14 0.9 13.1 0 12 0Z" fill="#D750A1" />
    </svg>
  );
};
export const CardIcon = props => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20 4H4C2.89 4 2.01 4.89 2.01 6L2 18C2 19.11 2.89 20 4 20H20C21.11 20 22 19.11 22 18V6C22 4.89 21.11 4 20 4ZM20 18H4V12H20V18ZM20 8H4V6H20V8Z" fill="#A6ABC9"/>
    </svg>
    

  );
};
export const FilledCardIcon = props => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20 4H4C2.89 4 2.01 4.89 2.01 6L2 18C2 19.11 2.89 20 4 20H20C21.11 20 22 19.11 22 18V6C22 4.89 21.11 4 20 4ZM20 18H4V12H20V18ZM20 8H4V6H20V8Z" fill="#EEF3FF" />
    </svg>

  );
};
export const PaymentIcon = props => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M7 6C7 3.23858 9.23858 1 12 1C14.7614 1 17 3.23858 17 6H19C20.6569 6 22 7.34315 22 9V18C22 20.7614 19.7614 23 17 23H7C4.23858 23 2 20.7614 2 18V9C2 7.34315 3.34315 6 5 6H7ZM9 6C9 4.34315 10.3431 3 12 3C13.6569 3 15 4.34315 15 6H9ZM7 8V11C7 11.5523 7.44772 12 8 12C8.55228 12 9 11.5523 9 11V8H15V11C15 11.5523 15.4477 12 16 12C16.5523 12 17 11.5523 17 11V8H19C19.5523 8 20 8.44772 20 9V18C20 19.6569 18.6569 21 17 21H7C5.34315 21 4 19.6569 4 18V9C4 8.44772 4.44772 8 5 8H7Z" fill="#A6ABC9"/>
    </svg>
    
    

  );
};
export const FiiledPaymentIcon = props => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M7 6C7 3.23858 9.23858 1 12 1C14.7614 1 17 3.23858 17 6H19C20.6569 6 22 7.34315 22 9V18C22 20.7614 19.7614 23 17 23H7C4.23858 23 2 20.7614 2 18V9C2 7.34315 3.34315 6 5 6H7ZM9 6C9 4.34315 10.3431 3 12 3C13.6569 3 15 4.34315 15 6H9ZM7 8V11C7 11.5523 7.44772 12 8 12C8.55228 12 9 11.5523 9 11V8H15V11C15 11.5523 15.4477 12 16 12C16.5523 12 17 11.5523 17 11V8H19C19.5523 8 20 8.44772 20 9V18C20 19.6569 18.6569 21 17 21H7C5.34315 21 4 19.6569 4 18V9C4 8.44772 4.44772 8 5 8H7Z" fill="#EEF3FF"/>
    </svg>
    
    
    

  );
};
export const DotsIcon = ({ fill = '#797F92', ...props }) => {
  return (
    <svg width="17" height="4" viewBox="0 0 17 4" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <ellipse cx="2" cy="2" rx="2" ry="2" fill={fill} />
      <ellipse cx="8.3999" cy="2" rx="2" ry="2" fill={fill} />
      <circle cx="14.7998" cy="2" r="2" fill={fill} />
    </svg>
  );
};
export const XIcon = props => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 58.878 45.103">
      <path
        d="M60.925,15.032H6.953A2.46,2.46,0,0,1,4.5,12.578h0a2.46,2.46,0,0,1,2.453-2.453H60.925a2.46,2.46,0,0,1,2.453,2.453h0A2.46,2.46,0,0,1,60.925,15.032Z"
        transform="translate(14.447 -10.341) rotate(45)"
      />
      <path
        d="M60.925,28.532H6.953A2.46,2.46,0,0,1,4.5,26.078h0a2.46,2.46,0,0,1,2.453-2.453H60.925a2.46,2.46,0,0,1,2.453,2.453h0A2.46,2.46,0,0,1,60.925,28.532Z"
        transform="translate(-12.887 28.11) rotate(-45)"
      />
    </svg>
  );
};
export const CancelMenu = props => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.3 5.70997C17.91 5.31997 17.28 5.31997 16.89 5.70997L12 10.59L7.10997 5.69997C6.71997 5.30997 6.08997 5.30997 5.69997 5.69997C5.30997 6.08997 5.30997 6.71997 5.69997 7.10997L10.59 12L5.69997 16.89C5.30997 17.28 5.30997 17.91 5.69997 18.3C6.08997 18.69 6.71997 18.69 7.10997 18.3L12 13.41L16.89 18.3C17.28 18.69 17.91 18.69 18.3 18.3C18.69 17.91 18.69 17.28 18.3 16.89L13.41 12L18.3 7.10997C18.68 6.72997 18.68 6.08997 18.3 5.70997Z"
        fill="white"
      />
    </svg>
  );
};
export const MenuProfile = props => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 5.9C13.16 5.9 14.1 6.84 14.1 8C14.1 9.16 13.16 10.1 12 10.1C10.84 10.1 9.9 9.16 9.9 8C9.9 6.84 10.84 5.9 12 5.9ZM12 14.9C14.97 14.9 18.1 16.36 18.1 17V18.1H5.9V17C5.9 16.36 9.03 14.9 12 14.9ZM12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4ZM12 13C9.33 13 4 14.34 4 17V20H20V17C20 14.34 14.67 13 12 13Z"
        fill="white"
      />
    </svg>
  );
};
export const MenuBookmarks = props => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17 3H7C5.9 3 5 3.9 5 5V21L12 18L19 21V5C19 3.9 18.1 3 17 3ZM17 18L12 15.82L7 18V5H17V18Z"
        fill="white"
      />
    </svg>
  );
};
export const MenuSettings = props => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.43 12.98C19.47 12.66 19.5 12.34 19.5 12C19.5 11.66 19.47 11.34 19.43 11.02L21.54 9.37C21.73 9.22 21.78 8.95 21.66 8.73L19.66 5.27C19.57 5.11 19.4 5.02 19.22 5.02C19.16 5.02 19.1 5.03 19.05 5.05L16.56 6.05C16.04 5.65 15.48 5.32 14.87 5.07L14.49 2.42C14.46 2.18 14.25 2 14 2H9.99996C9.74996 2 9.53996 2.18 9.50996 2.42L9.12996 5.07C8.51996 5.32 7.95996 5.66 7.43996 6.05L4.94996 5.05C4.88996 5.03 4.82996 5.02 4.76996 5.02C4.59996 5.02 4.42996 5.11 4.33996 5.27L2.33996 8.73C2.20996 8.95 2.26996 9.22 2.45996 9.37L4.56996 11.02C4.52996 11.34 4.49996 11.67 4.49996 12C4.49996 12.33 4.52996 12.66 4.56996 12.98L2.45996 14.63C2.26996 14.78 2.21996 15.05 2.33996 15.27L4.33996 18.73C4.42996 18.89 4.59996 18.98 4.77996 18.98C4.83996 18.98 4.89996 18.97 4.94996 18.95L7.43996 17.95C7.95996 18.35 8.51996 18.68 9.12996 18.93L9.50996 21.58C9.53996 21.82 9.74996 22 9.99996 22H14C14.25 22 14.46 21.82 14.49 21.58L14.87 18.93C15.48 18.68 16.04 18.34 16.56 17.95L19.05 18.95C19.11 18.97 19.17 18.98 19.23 18.98C19.4 18.98 19.57 18.89 19.66 18.73L21.66 15.27C21.78 15.05 21.73 14.78 21.54 14.63L19.43 12.98ZM17.45 11.27C17.49 11.58 17.5 11.79 17.5 12C17.5 12.21 17.48 12.43 17.45 12.73L17.31 13.86L18.2 14.56L19.28 15.4L18.58 16.61L17.31 16.1L16.27 15.68L15.37 16.36C14.94 16.68 14.53 16.92 14.12 17.09L13.06 17.52L12.9 18.65L12.7 20H11.3L11.11 18.65L10.95 17.52L9.88996 17.09C9.45996 16.91 9.05996 16.68 8.65996 16.38L7.74996 15.68L6.68996 16.11L5.41996 16.62L4.71996 15.41L5.79996 14.57L6.68996 13.87L6.54996 12.74C6.51996 12.43 6.49996 12.2 6.49996 12C6.49996 11.8 6.51996 11.57 6.54996 11.27L6.68996 10.14L5.79996 9.44L4.71996 8.6L5.41996 7.39L6.68996 7.9L7.72996 8.32L8.62996 7.64C9.05996 7.32 9.46996 7.08 9.87996 6.91L10.94 6.48L11.1 5.35L11.3 4H12.69L12.88 5.35L13.04 6.48L14.1 6.91C14.53 7.09 14.93 7.32 15.33 7.62L16.24 8.32L17.3 7.89L18.57 7.38L19.27 8.59L18.2 9.44L17.31 10.14L17.45 11.27ZM12 8C9.78996 8 7.99996 9.79 7.99996 12C7.99996 14.21 9.78996 16 12 16C14.21 16 16 14.21 16 12C16 9.79 14.21 8 12 8ZM12 14C10.9 14 9.99996 13.1 9.99996 12C9.99996 10.9 10.9 10 12 10C13.1 10 14 10.9 14 12C14 13.1 13.1 14 12 14Z"
        fill="white"
      />
    </svg>
  );
};

export const ContactUs = props => {
  return (
    <svg width="24" height="24" viewBox="-2 -4 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20 2C20 0.9 19.1 0 18 0H2C0.9 0 0 0.9 0 2V14C0 15.1 0.9 16 2 16H18C19.1 16 20 15.1 20 14V2ZM18 2L10 6.99L2 2H18ZM18 14H2V4L10 9L18 4V14Z"
        fill="white"
      />
    </svg>
  );
};

export const MenuCard = props => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20 4H4C2.89 4 2.01 4.89 2.01 6L2 18C2 19.11 2.89 20 4 20H20C21.11 20 22 19.11 22 18V6C22 4.89 21.11 4 20 4ZM20 18H4V12H20V18ZM20 8H4V6H20V8Z"
        fill="white"
      />
    </svg>
  );
};
export const MenuBank = props => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9 11V15H7V11H9ZM5 9H7H9H11V11V15V17H9H7H5V15V11V9ZM17 11V15H15V11H17ZM13 9H15H17H19V11V15V17H17H15H13V15V11V9Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18 17H6C5.44772 17 5 17.4477 5 18C5 18.5523 5.44772 19 6 19H18C18.5523 19 19 18.5523 19 18C19 17.4477 18.5523 17 18 17ZM6 15C4.34315 15 3 16.3431 3 18C3 19.6569 4.34315 21 6 21H18C19.6569 21 21 19.6569 21 18C21 16.3431 19.6569 15 18 15H6Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.92866 9.00002H18.0713C18.5842 9.00002 19 8.58425 19 8.07136C19 7.67774 18.7518 7.32688 18.3807 7.19575L12.3331 5.05907C12.1176 4.98291 11.8824 4.98291 11.6669 5.05907L5.61929 7.19575C5.24815 7.32688 5 7.67774 5 8.07136C5 8.58425 5.41577 9.00002 5.92866 9.00002ZM4.95303 5.30999C3.78259 5.72352 3 6.83002 3 8.07136C3 9.68882 4.3112 11 5.92866 11H18.0713C19.6888 11 21 9.68882 21 8.07136C21 6.83002 20.2174 5.72352 19.047 5.30999L12.9994 3.17331C12.3527 2.94483 11.6473 2.94483 11.0006 3.17331L4.95303 5.30999Z"
        fill="white"
      />
    </svg>
  );
};
export const MenuSupport = props => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM11 16H13V18H11V16ZM12.61 6.04C10.55 5.74 8.73 7.01 8.18 8.83C8 9.41 8.44 10 9.05 10H9.25C9.66 10 9.99 9.71 10.13 9.33C10.45 8.44 11.4 7.83 12.43 8.05C13.38 8.25 14.08 9.18 14 10.15C13.9 11.49 12.38 11.78 11.55 13.03C11.55 13.04 11.54 13.04 11.54 13.05C11.53 13.07 11.52 13.08 11.51 13.1C11.42 13.25 11.33 13.42 11.26 13.6C11.25 13.63 11.23 13.65 11.22 13.68C11.21 13.7 11.21 13.72 11.2 13.75C11.08 14.09 11 14.5 11 15H13C13 14.58 13.11 14.23 13.28 13.93C13.3 13.9 13.31 13.87 13.33 13.84C13.41 13.7 13.51 13.57 13.61 13.45C13.62 13.44 13.63 13.42 13.64 13.41C13.74 13.29 13.85 13.18 13.97 13.07C14.93 12.16 16.23 11.42 15.96 9.51C15.72 7.77 14.35 6.3 12.61 6.04Z"
        fill="white"
      />
    </svg>
  );
};
export const MenuLang = props => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM18.92 8H15.97C15.65 6.75 15.19 5.55 14.59 4.44C16.43 5.07 17.96 6.35 18.92 8ZM12 4.04C12.83 5.24 13.48 6.57 13.91 8H10.09C10.52 6.57 11.17 5.24 12 4.04ZM4.26 14C4.1 13.36 4 12.69 4 12C4 11.31 4.1 10.64 4.26 10H7.64C7.56 10.66 7.5 11.32 7.5 12C7.5 12.68 7.56 13.34 7.64 14H4.26ZM5.08 16H8.03C8.35 17.25 8.81 18.45 9.41 19.56C7.57 18.93 6.04 17.66 5.08 16ZM8.03 8H5.08C6.04 6.34 7.57 5.07 9.41 4.44C8.81 5.55 8.35 6.75 8.03 8ZM12 19.96C11.17 18.76 10.52 17.43 10.09 16H13.91C13.48 17.43 12.83 18.76 12 19.96ZM14.34 14H9.66C9.57 13.34 9.5 12.68 9.5 12C9.5 11.32 9.57 10.65 9.66 10H14.34C14.43 10.65 14.5 11.32 14.5 12C14.5 12.68 14.43 13.34 14.34 14ZM14.59 19.56C15.19 18.45 15.65 17.25 15.97 16H18.92C17.96 17.65 16.43 18.93 14.59 19.56ZM16.36 14C16.44 13.34 16.5 12.68 16.5 12C16.5 11.32 16.44 10.66 16.36 10H19.74C19.9 10.64 20 11.31 20 12C20 12.69 19.9 13.36 19.74 14H16.36Z"
        fill="white"
      />
    </svg>
  );
};
export const MenuLogout = props => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11 20C11 19.4477 11.4477 19 12 19L15.2 19C16.0565 19 16.6388 18.9992 17.0889 18.9624C17.5273 18.9266 17.7515 18.8617 17.9079 18.782C18.2843 18.5903 18.5902 18.2843 18.782 17.908C18.8617 17.7516 18.9266 17.5274 18.9624 17.089C18.9992 16.6389 19 16.0566 19 15.2L19 8.8C19 7.94342 18.9992 7.36113 18.9624 6.91104C18.9266 6.47262 18.8617 6.24842 18.782 6.09202C18.5902 5.71569 18.2843 5.40973 17.9079 5.21799C17.7515 5.1383 17.5273 5.07337 17.0889 5.03755C16.6388 5.00078 16.0565 5 15.2 5L12 5C11.4477 5 11 4.55228 11 4C11 3.44772 11.4477 3 12 3L15.2413 3C16.0462 2.99999 16.7106 2.99998 17.2518 3.04419C17.8139 3.09012 18.3306 3.18868 18.8159 3.43597C19.5686 3.81947 20.1805 4.43139 20.564 5.18404C20.8113 5.66937 20.9098 6.18608 20.9558 6.74817C21 7.28937 21 7.95374 21 8.75872V15.2413C21 16.0463 21 16.7106 20.9558 17.2518C20.9098 17.8139 20.8113 18.3306 20.564 18.816C20.1805 19.5686 19.5686 20.1805 18.8159 20.564C18.3306 20.8113 17.8139 20.9099 17.2518 20.9558C16.7106 21 16.0462 21 15.2413 21H12C11.4477 21 11 20.5523 11 20Z"
        fill="white"
      />
      <path
        d="M7.70711 14.2929C8.09763 14.6834 8.09763 15.3166 7.70711 15.7071C7.31658 16.0976 6.68342 16.0976 6.29289 15.7071L3.29289 12.7071C2.90237 12.3166 2.90237 11.6834 3.29289 11.2929L6.29289 8.29289C6.68342 7.90237 7.31658 7.90237 7.70711 8.29289C8.09763 8.68342 8.09763 9.31658 7.70711 9.70711L6.41421 11H15C15.5523 11 16 11.4477 16 12C16 12.5523 15.5523 13 15 13H6.41421L7.70711 14.2929Z"
        fill="white"
      />
    </svg>
  );
};
export const MenuArrow = props => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.37999 21.0098C7.86999 21.4998 8.65999 21.4998 9.14999 21.0098L17.46 12.6998C17.85 12.3098 17.85 11.6798 17.46 11.2898L9.14999 2.9798C8.65999 2.4898 7.86999 2.4898 7.37999 2.9798C6.88999 3.4698 6.88999 4.2598 7.37999 4.7498L14.62 11.9998L7.36999 19.2498C6.88999 19.7298 6.88999 20.5298 7.37999 21.0098Z"
        fill="#686F8D"
      />
    </svg>
  );
};

export const ValidVectorIcon = props =>{
  return(
    <svg {...props}  width="18" height="13" viewBox="0 0 18 13" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.99989 10.1699L2.52989 6.69995C2.13989 6.30995 1.50989 6.30995 1.11989 6.69995C0.729893 7.08995 0.729893 7.71995 1.11989 8.10995L5.29989 12.2899C5.68989 12.6799 6.31989 12.6799 6.70989 12.2899L17.2899 1.70995C17.6799 1.31995 17.6799 0.689946 17.2899 0.299946C16.8999 -0.0900537 16.2699 -0.0900537 15.8799 0.299946L5.99989 10.1699Z" fill="#36CFFF"/>
</svg>

  );
};

export const EmptyBookmark = props => {
  return (
    <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M38.25 6.75H15.75C13.275 6.75 11.25 8.775 11.25 11.25V47.25L27 40.5L42.75 47.25V11.25C42.75 8.775 40.725 6.75 38.25 6.75ZM38.25 40.5L27 35.595L15.75 40.5V13.5C15.75 12.2625 16.7625 11.25 18 11.25H36C37.2375 11.25 38.25 12.2625 38.25 13.5V40.5Z"
        fill="#253245"
      />
    </svg>
  );
};
export const DeleteImg = props => {
  return (
    <svg {...props} width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d)">
        <path
          d="M15 25C20.5228 25 25 20.5228 25 15C25 9.47715 20.5228 5 15 5C9.47715 5 5 9.47715 5 15C5 20.5228 9.47715 25 15 25Z"
          fill="#E7EAF3"
        />
        <path d="M18 12L12 18" stroke="#10161E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M12 12L18 18" stroke="#10161E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </g>
      <defs>
        <filter
          id="filter0_d"
          x="-2"
          y="-2"
          width="34"
          height="34"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset />
          <feGaussianBlur stdDeviation="2.5" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0862745 0 0 0 0 0.117647 0 0 0 1 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
      </defs>
    </svg>
  );
};
export const BurgerMenuIcon = props => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 58.878 34.346">
      <path
        d="M60.925,15.032H6.953A2.46,2.46,0,0,1,4.5,12.578h0a2.46,2.46,0,0,1,2.453-2.453H60.925a2.46,2.46,0,0,1,2.453,2.453h0A2.46,2.46,0,0,1,60.925,15.032Z"
        transform="translate(-4.5 -10.125)"
      />
      <path
        d="M60.925,21.782H6.953A2.46,2.46,0,0,1,4.5,19.328h0a2.46,2.46,0,0,1,2.453-2.453H60.925a2.46,2.46,0,0,1,2.453,2.453h0A2.46,2.46,0,0,1,60.925,21.782Z"
        transform="translate(-4.5 -2.156)"
      />
      <path
        d="M60.925,28.532H6.953A2.46,2.46,0,0,1,4.5,26.078h0a2.46,2.46,0,0,1,2.453-2.453H60.925a2.46,2.46,0,0,1,2.453,2.453h0A2.46,2.46,0,0,1,60.925,28.532Z"
        transform="translate(-4.5 5.814)"
      />
    </svg>
  );
};
export const ContactError = props => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.4099 11.9999L19.7099 5.70994C19.8982 5.52164 20.004 5.26624 20.004 4.99994C20.004 4.73364 19.8982 4.47825 19.7099 4.28994C19.5216 4.10164 19.2662 3.99585 18.9999 3.99585C18.7336 3.99585 18.4782 4.10164 18.2899 4.28994L11.9999 10.5899L5.70994 4.28994C5.52164 4.10164 5.26624 3.99585 4.99994 3.99585C4.73364 3.99585 4.47824 4.10164 4.28994 4.28994C4.10164 4.47825 3.99585 4.73364 3.99585 4.99994C3.99585 5.26624 4.10164 5.52164 4.28994 5.70994L10.5899 11.9999L4.28994 18.2899C4.19621 18.3829 4.12182 18.4935 4.07105 18.6154C4.02028 18.7372 3.99414 18.8679 3.99414 18.9999C3.99414 19.132 4.02028 19.2627 4.07105 19.3845C4.12182 19.5064 4.19621 19.617 4.28994 19.7099C4.3829 19.8037 4.4935 19.8781 4.61536 19.9288C4.73722 19.9796 4.86793 20.0057 4.99994 20.0057C5.13195 20.0057 5.26266 19.9796 5.38452 19.9288C5.50638 19.8781 5.61698 19.8037 5.70994 19.7099L11.9999 13.4099L18.2899 19.7099C18.3829 19.8037 18.4935 19.8781 18.6154 19.9288C18.7372 19.9796 18.8679 20.0057 18.9999 20.0057C19.132 20.0057 19.2627 19.9796 19.3845 19.9288C19.5064 19.8781 19.617 19.8037 19.7099 19.7099C19.8037 19.617 19.8781 19.5064 19.9288 19.3845C19.9796 19.2627 20.0057 19.132 20.0057 18.9999C20.0057 18.8679 19.9796 18.7372 19.9288 18.6154C19.8781 18.4935 19.8037 18.3829 19.7099 18.2899L13.4099 11.9999Z"
        fill="#E7EAF3"
      />
    </svg>
  );
};
export const HomeIcon = props => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d)">
    <path d="M24.0001 12L18.0001 6.74001C17.4501 6.24805 16.738 5.97607 16.0001 5.97607C15.2622 5.97607 14.5501 6.24805 14.0001 6.74001L8.00009 12C7.68246 12.2841 7.42899 12.6326 7.25657 13.0223C7.08414 13.4119 6.99671 13.8339 7.00009 14.26V23C7.00009 23.7957 7.31617 24.5587 7.87877 25.1213C8.44138 25.6839 9.20445 26 10.0001 26H22.0001C22.7957 26 23.5588 25.6839 24.1214 25.1213C24.684 24.5587 25.0001 23.7957 25.0001 23V14.25C25.0021 13.8256 24.9139 13.4055 24.7416 13.0177C24.5692 12.6298 24.3165 12.283 24.0001 12ZM18.0001 24H14.0001V19C14.0001 18.7348 14.1055 18.4804 14.293 18.2929C14.4805 18.1054 14.7349 18 15.0001 18H17.0001C17.2653 18 17.5197 18.1054 17.7072 18.2929C17.8947 18.4804 18.0001 18.7348 18.0001 19V24ZM23.0001 23C23.0001 23.2652 22.8947 23.5196 22.7072 23.7071C22.5197 23.8946 22.2653 24 22.0001 24H20.0001V19C20.0001 18.2044 19.684 17.4413 19.1214 16.8787C18.5588 16.3161 17.7957 16 17.0001 16H15.0001C14.2044 16 13.4414 16.3161 12.8788 16.8787C12.3162 17.4413 12.0001 18.2044 12.0001 19V24H10.0001C9.73488 24 9.48052 23.8946 9.29299 23.7071C9.10545 23.5196 9.00009 23.2652 9.00009 23V14.25C9.00027 14.108 9.03069 13.9677 9.08931 13.8384C9.14794 13.7091 9.23343 13.5937 9.3401 13.5L15.3401 8.25001C15.5226 8.08969 15.7572 8.00127 16.0001 8.00127C16.243 8.00127 16.4776 8.08969 16.6601 8.25001L22.6601 13.5C22.7668 13.5937 22.8523 13.7091 22.9109 13.8384C22.9695 13.9677 22.9999 14.108 23.0001 14.25V23Z" fill="#E7EAF3"/>
    </g>
    <defs>
    <filter id="filter0_d" x="0" y="0" width="32" height="32" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feOffset/>
    <feGaussianBlur stdDeviation="2"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0862745 0 0 0 0 0.117647 0 0 0 1 0"/>
    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
    </filter>
    </defs>
    </svg>
    
  );
};
export const HomeIconActive = props => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_di)">
<path d="M24.0001 12L18.0001 6.74001C17.4501 6.24805 16.738 5.97607 16.0001 5.97607C15.2622 5.97607 14.5501 6.24805 14.0001 6.74001L8.00009 12C7.68246 12.2841 7.42899 12.6326 7.25657 13.0223C7.08414 13.4119 6.99671 13.8339 7.00009 14.26V23C7.00009 23.7957 7.31617 24.5587 7.87877 25.1213C8.44138 25.6839 9.20445 26 10.0001 26H22.0001C22.7957 26 23.5588 25.6839 24.1214 25.1213C24.684 24.5587 25.0001 23.7957 25.0001 23V14.25C25.0021 13.8256 24.9139 13.4055 24.7416 13.0177C24.5692 12.6298 24.3165 12.283 24.0001 12ZM18.0001 24H14.0001V19C14.0001 18.7348 14.1055 18.4804 14.293 18.2929C14.4805 18.1054 14.7349 18 15.0001 18H17.0001C17.2653 18 17.5197 18.1054 17.7072 18.2929C17.8947 18.4804 18.0001 18.7348 18.0001 19V24ZM23.0001 23C23.0001 23.2652 22.8947 23.5196 22.7072 23.7071C22.5197 23.8946 22.2653 24 22.0001 24H20.0001V19C20.0001 18.2044 19.684 17.4413 19.1214 16.8787C18.5588 16.3161 17.7957 16 17.0001 16H15.0001C14.2044 16 13.4414 16.3161 12.8788 16.8787C12.3162 17.4413 12.0001 18.2044 12.0001 19V24H10.0001C9.73488 24 9.48052 23.8946 9.29299 23.7071C9.10545 23.5196 9.00009 23.2652 9.00009 23V14.25C9.00027 14.108 9.03069 13.9677 9.08931 13.8384C9.14794 13.7091 9.23343 13.5937 9.3401 13.5L15.3401 8.25001C15.5226 8.08969 15.7572 8.00127 16.0001 8.00127C16.243 8.00127 16.4776 8.08969 16.6601 8.25001L22.6601 13.5C22.7668 13.5937 22.8523 13.7091 22.9109 13.8384C22.9695 13.9677 22.9999 14.108 23.0001 14.25V23Z" fill="#E7EAF3"/>
</g>
<defs>
<filter id="filter0_di" x="0" y="0" width="32" height="32" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="2"/>
<feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0 0 0 0 0 0.66 0 0 0 1 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="0.2" dy="0.2"/>
<feGaussianBlur stdDeviation="0.5"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0 0 0 0 0 0.36 0 0 0 1 0"/>
<feBlend mode="normal" in2="shape" result="effect2_innerShadow"/>
</filter>
</defs>
</svg>
  );
};
export const BellIcon = props => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g filter="url(#filter0_d_11353:9055)">
      <path d="M21.28 12.64C21.28 11.1124 20.6732 9.64728 19.5929 8.56707C18.5127 7.48686 17.0477 6.88 15.52 6.88C13.9924 6.88 12.5273 7.48686 11.4471 8.56707C10.3669 9.64728 9.76 11.1124 9.76 12.64C9.76 19.36 6.88 21.28 6.88 21.28H24.16C24.16 21.28 21.28 19.36 21.28 12.64Z" stroke="#E7EAF3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M17.1808 25.12C17.012 25.411 16.7698 25.6525 16.4783 25.8203C16.1868 25.9882 15.8564 26.0766 15.52 26.0766C15.1836 26.0766 14.8532 25.9882 14.5617 25.8203C14.2702 25.6525 14.028 25.411 13.8592 25.12" stroke="#E7EAF3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </g>
      <defs>
      <filter id="filter0_d_11353:9055" x="0" y="0" width="32" height="32" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feOffset/>
      <feGaussianBlur stdDeviation="2"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0862745 0 0 0 0 0.117647 0 0 0 1 0"/>
      <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_11353:9055"/>
      <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_11353:9055" result="shape"/>
      </filter>
      </defs>
    </svg>
  );
};

export const BellIconActive = props => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_di)">
    <g clip-path="url(#clip0)">
    <path d="M21.2799 12.64C21.2799 11.1124 20.673 9.64728 19.5928 8.56707C18.5126 7.48686 17.0475 6.88 15.5199 6.88C13.9922 6.88 12.5272 7.48686 11.4469 8.56707C10.3667 9.64728 9.75988 11.1124 9.75988 12.64C9.75988 19.36 6.87988 21.28 6.87988 21.28H24.1599C24.1599 21.28 21.2799 19.36 21.2799 12.64Z" stroke="#E7EAF3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M17.181 25.12C17.0122 25.411 16.7699 25.6525 16.4785 25.8203C16.187 25.9882 15.8565 26.0766 15.5202 26.0766C15.1838 26.0766 14.8533 25.9882 14.5619 25.8203C14.2704 25.6525 14.0282 25.411 13.8594 25.12" stroke="#E7EAF3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    </g>
    <defs>
    <filter id="filter0_di" x="0" y="0" width="32" height="32" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feOffset/>
    <feGaussianBlur stdDeviation="2"/>
    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0 0 0 0 0 0.66 0 0 0 1 0"/>
    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feOffset dx="0.2" dy="0.2"/>
    <feGaussianBlur stdDeviation="0.5"/>
    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0 0 0 0 0 0.36 0 0 0 1 0"/>
    <feBlend mode="normal" in2="shape" result="effect2_innerShadow"/>
    </filter>
    <clipPath id="clip0">
    <rect width="23.04" height="23.04" fill="white" transform="translate(4 4.95996)"/>
    </clipPath>
    </defs>
    </svg>
    
  );
};
export const MailIcon = props => {
  return (
    <svg width="28" height="30" viewBox="0 0 28 30" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g filter="url(#filter0_d)">
        <line
          x1="10.9"
          y1="13.0856"
          x2="17.1"
          y2="13.0856"
          stroke="#E7EAF3"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <mask id="path-2-inside-1" fill="white">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14 24.5637C19.5228 24.5637 24 20.1836 24 14.7805C24 9.37745 19.5228 4.99738 14 4.99738C8.47715 4.99738 4 9.37745 4 14.7805C4 16.8212 4.63864 18.7159 5.73105 20.2839L5.27228 23.8744C5.17469 24.6382 5.94075 25.2211 6.65088 24.9234L9.73322 23.631C11.0273 24.2292 12.4737 24.5637 14 24.5637Z"
          />
        </mask>
        <path
          d="M5.73105 20.2839L7.71492 20.5373L7.81259 19.7729L7.37204 19.1405L5.73105 20.2839ZM5.27228 23.8744L3.28841 23.6209H3.28841L5.27228 23.8744ZM6.65088 24.9234L5.87755 23.0789H5.87754L6.65088 24.9234ZM9.73322 23.631L10.5724 21.8156L9.77251 21.4459L8.95989 21.7866L9.73322 23.631ZM22 14.7805C22 19.038 18.4598 22.5637 14 22.5637V26.5637C20.5859 26.5637 26 21.3293 26 14.7805H22ZM14 6.99738C18.4598 6.99738 22 10.5231 22 14.7805H26C26 8.23177 20.5859 2.99738 14 2.99738V6.99738ZM6 14.7805C6 10.5231 9.54016 6.99738 14 6.99738V2.99738C7.41414 2.99738 2 8.23177 2 14.7805H6ZM7.37204 19.1405C6.50411 17.8948 6 16.3965 6 14.7805H2C2 17.2459 2.77317 19.537 4.09006 21.4272L7.37204 19.1405ZM7.25615 24.1279L7.71492 20.5373L3.74717 20.0304L3.28841 23.6209L7.25615 24.1279ZM5.87754 23.0789C6.58768 22.7812 7.35374 23.3641 7.25615 24.1279L3.28841 23.6209C2.99563 25.9124 5.29383 27.661 7.42422 26.7678L5.87754 23.0789ZM8.95989 21.7866L5.87755 23.0789L7.42421 26.7678L10.5066 25.4755L8.95989 21.7866ZM14 22.5637C12.7684 22.5637 11.6079 22.2942 10.5724 21.8156L8.89407 25.4465C10.4468 26.1642 12.1791 26.5637 14 26.5637V22.5637Z"
          fill="#E7EAF3"
          mask="url(#path-2-inside-1)"
        />
        <line
          x1="10.9"
          y1="17.0803"
          x2="17.1"
          y2="17.0803"
          stroke="#E7EAF3"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <filter
          id="filter0_d"
          x="-2"
          y="-1"
          width="32"
          height="32"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0862745 0 0 0 0 0.117647 0 0 0 1 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
      </defs>
    </svg>
  );
};

export const MailIconActive = props => {
  return (
    <svg width="28" height="30" viewBox="0 0 28 30" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g filter="url(#filter0_di)">
        <line
          x1="10.9"
          y1="13.0856"
          x2="17.1"
          y2="13.0856"
          stroke="#E7EAF3"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <mask id="path-2-inside-1" fill="white">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14 24.5637C19.5228 24.5637 24 20.1836 24 14.7805C24 9.37745 19.5228 4.99738 14 4.99738C8.47715 4.99738 4 9.37745 4 14.7805C4 16.8212 4.63864 18.7159 5.73105 20.2839L5.27228 23.8744C5.17469 24.6382 5.94075 25.2211 6.65088 24.9234L9.73322 23.631C11.0273 24.2292 12.4737 24.5637 14 24.5637Z"
          />
        </mask>
        <path
          d="M5.73105 20.2839L7.71492 20.5373L7.81259 19.7729L7.37204 19.1405L5.73105 20.2839ZM5.27228 23.8744L3.28841 23.6209H3.28841L5.27228 23.8744ZM6.65088 24.9234L5.87755 23.0789H5.87754L6.65088 24.9234ZM9.73322 23.631L10.5724 21.8156L9.77251 21.4459L8.95989 21.7866L9.73322 23.631ZM22 14.7805C22 19.038 18.4598 22.5637 14 22.5637V26.5637C20.5859 26.5637 26 21.3293 26 14.7805H22ZM14 6.99738C18.4598 6.99738 22 10.5231 22 14.7805H26C26 8.23177 20.5859 2.99738 14 2.99738V6.99738ZM6 14.7805C6 10.5231 9.54016 6.99738 14 6.99738V2.99738C7.41414 2.99738 2 8.23177 2 14.7805H6ZM7.37204 19.1405C6.50411 17.8948 6 16.3965 6 14.7805H2C2 17.2459 2.77317 19.537 4.09006 21.4272L7.37204 19.1405ZM7.25615 24.1279L7.71492 20.5373L3.74717 20.0304L3.28841 23.6209L7.25615 24.1279ZM5.87754 23.0789C6.58768 22.7812 7.35374 23.3641 7.25615 24.1279L3.28841 23.6209C2.99563 25.9124 5.29383 27.661 7.42422 26.7678L5.87754 23.0789ZM8.95989 21.7866L5.87755 23.0789L7.42421 26.7678L10.5066 25.4755L8.95989 21.7866ZM14 22.5637C12.7684 22.5637 11.6079 22.2942 10.5724 21.8156L8.89407 25.4465C10.4468 26.1642 12.1791 26.5637 14 26.5637V22.5637Z"
          fill="#E7EAF3"
          mask="url(#path-2-inside-1)"
        />
        <line
          x1="10.9"
          y1="17.0803"
          x2="17.1"
          y2="17.0803"
          stroke="#E7EAF3"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <filter
          id="filter0_di"
          x="-2"
          y="-1"
          width="32"
          height="32"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0 0 0 0 0 0.66 0 0 0 1 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="0.2" dy="0.2" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0 0 0 0 0 0.36 0 0 0 1 0" />
          <feBlend mode="normal" in2="shape" result="effect2_innerShadow" />
        </filter>
      </defs>
    </svg>
  );
};
export const PlusCircleIcon = props => {
  return (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g filter="url(#filter0_d_11353:8766)">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M8.63603 21.3638C12.1507 24.8786 17.8492 24.8786 21.3639 21.3638C24.8786 17.8491 24.8786 12.1507 21.3639 8.63598C17.8492 5.12127 12.1507 5.12127 8.63603 8.63598C5.12132 12.1507 5.12132 17.8491 8.63603 21.3638ZM7.22181 22.7781C11.5176 27.0738 18.4824 27.0738 22.7781 22.7781C27.0739 18.4823 27.0739 11.5175 22.7781 7.22176C18.4824 2.92601 11.5176 2.92601 7.22181 7.22177C2.92606 11.5175 2.92606 18.4823 7.22181 22.7781Z" fill="#E7EAF3"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M16 10.6459C16 10.0936 15.5523 9.64587 15 9.64587C14.4478 9.64587 14 10.0936 14 10.6459V14.0001L10.4167 14.0001C9.8644 14.0001 9.41669 14.4478 9.41669 15.0001C9.41669 15.5523 9.8644 16.0001 10.4167 16.0001L14 16.0001V20.0417C14 20.594 14.4478 21.0417 15 21.0417C15.5523 21.0417 16 20.594 16 20.0417V16.0001L19.8126 16.0001C20.3648 16.0001 20.8126 15.5523 20.8126 15.0001C20.8126 14.4478 20.3648 14.0001 19.8126 14.0001L16 14.0001V10.6459Z" fill="#E7EAF3"/>
      </g>
      <defs>
      <filter id="filter0_d_11353:8766" x="0" y="0" width="29.9999" height="30" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feOffset/>
      <feGaussianBlur stdDeviation="2"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0862745 0 0 0 0 0.117647 0 0 0 1 0"/>
      <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_11353:8766"/>
      <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_11353:8766" result="shape"/>
      </filter>
      </defs>
    </svg>
  );
};
 
export const PlusCircleIconActive = props => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_di)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M8.92893 23.0711C12.8342 26.9763 19.1658 26.9763 23.0711 23.0711C26.9763 19.1659 26.9763 12.8342 23.0711 8.929C19.1658 5.02377 12.8342 5.02377 8.92893 8.929C5.02369 12.8342 5.02369 19.1659 8.92893 23.0711ZM7.51472 24.4853C12.201 29.1716 19.799 29.1716 24.4853 24.4853C29.1716 19.799 29.1716 12.2011 24.4853 7.51479C19.799 2.82851 12.201 2.82851 7.51472 7.51479C2.82843 12.2011 2.82843 19.799 7.51472 24.4853Z" fill="#E7EAF3"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M17 11.25C17 10.6977 16.5523 10.25 16 10.25C15.4477 10.25 15 10.6977 15 11.25V15L11 15C10.4477 15 10 15.4477 10 16C10 16.5523 10.4477 17 11 17L15 17V21.5C15 22.0523 15.4477 22.5 16 22.5C16.5523 22.5 17 22.0523 17 21.5V17L21.2501 17C21.8024 17 22.2501 16.5523 22.2501 16C22.2501 15.4477 21.8024 15 21.2501 15L17 15V11.25Z" fill="#E7EAF3"/>
</g>
<defs>
<filter id="filter0_di" x="-4" y="-4" width="40" height="40" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="2"/>
<feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0 0 0 0 0 0.66 0 0 0 1 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="0.2" dy="0.2"/>
<feGaussianBlur stdDeviation="0.5"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0 0 0 0 0 0.36 0 0 0 1 0"/>
<feBlend mode="normal" in2="shape" result="effect2_innerShadow"/>
</filter>
</defs>
</svg>
  );
};

export const ProfileIcon = props => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g filter="url(#filter0_d)">
        <path
          d="M13 15C13.1978 15 13.3911 14.9414 13.5556 14.8315C13.72 14.7216 13.8482 14.5654 13.9239 14.3827C13.9996 14.2 14.0194 13.9989 13.9808 13.8049C13.9422 13.6109 13.847 13.4327 13.7071 13.2929C13.5673 13.153 13.3891 13.0578 13.1951 13.0192C13.0011 12.9806 12.8 13.0004 12.6173 13.0761C12.4346 13.1518 12.2784 13.28 12.1685 13.4444C12.0587 13.6089 12 13.8022 12 14C12 14.2652 12.1054 14.5196 12.2929 14.7071C12.4804 14.8946 12.7348 15 13 15ZM16 6C14.0222 6 12.0888 6.58649 10.4443 7.6853C8.79981 8.78412 7.51809 10.3459 6.76121 12.1732C6.00433 14.0004 5.8063 16.0111 6.19215 17.9509C6.578 19.8907 7.53041 21.6725 8.92894 23.0711C10.3275 24.4696 12.1093 25.422 14.0491 25.8079C15.9889 26.1937 17.9996 25.9957 19.8268 25.2388C21.6541 24.4819 23.2159 23.2002 24.3147 21.5557C25.4135 19.9112 26 17.9778 26 16C26 14.6868 25.7413 13.3864 25.2388 12.1732C24.7363 10.9599 23.9997 9.85752 23.0711 8.92893C22.1425 8.00035 21.0401 7.26375 19.8268 6.7612C18.6136 6.25866 17.3132 6 16 6ZM16 24C14.4178 24 12.871 23.5308 11.5554 22.6518C10.2398 21.7727 9.21447 20.5233 8.60897 19.0615C8.00347 17.5997 7.84504 15.9911 8.15372 14.4393C8.4624 12.8874 9.22433 11.462 10.3432 10.3431C11.462 9.22433 12.8874 8.4624 14.4393 8.15372C15.9911 7.84504 17.5997 8.00346 19.0615 8.60896C20.5233 9.21447 21.7727 10.2398 22.6518 11.5554C23.5308 12.871 24 14.4177 24 16C24 18.1217 23.1572 20.1566 21.6569 21.6569C20.1566 23.1571 18.1217 24 16 24ZM19 17H13C12.7348 17 12.4804 17.1054 12.2929 17.2929C12.1054 17.4804 12 17.7348 12 18C12 19.0609 12.4214 20.0783 13.1716 20.8284C13.9217 21.5786 14.9391 22 16 22C17.0609 22 18.0783 21.5786 18.8284 20.8284C19.5786 20.0783 20 19.0609 20 18C20 17.7348 19.8946 17.4804 19.7071 17.2929C19.5196 17.1054 19.2652 17 19 17ZM16 20C15.6493 19.9996 15.3048 19.9071 15.0012 19.7315C14.6975 19.556 14.4454 19.3037 14.27 19H17.73C17.5546 19.3037 17.3025 19.556 16.9988 19.7315C16.6952 19.9071 16.3507 19.9996 16 20ZM19 13C18.8022 13 18.6089 13.0586 18.4444 13.1685C18.28 13.2784 18.1518 13.4346 18.0761 13.6173C18.0004 13.8 17.9806 14.0011 18.0192 14.1951C18.0578 14.3891 18.153 14.5673 18.2929 14.7071C18.4328 14.847 18.6109 14.9422 18.8049 14.9808C18.9989 15.0194 19.2 14.9996 19.3827 14.9239C19.5654 14.8482 19.7216 14.72 19.8315 14.5556C19.9414 14.3911 20 14.1978 20 14C20 13.7348 19.8946 13.4804 19.7071 13.2929C19.5196 13.1054 19.2652 13 19 13Z"
          fill="#E7EAF3"
        />
      </g>
      <defs>
        <filter
          id="filter0_d"
          x="0"
          y="0"
          width="32"
          height="32"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0862745 0 0 0 0 0.117647 0 0 0 1 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
      </defs>
    </svg>
  );
};

export const ProfileIconActive = props => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g filter="url(#filter0_di)">
        <path
          d="M13 15C13.1978 15 13.3911 14.9414 13.5556 14.8315C13.72 14.7216 13.8482 14.5654 13.9239 14.3827C13.9996 14.2 14.0194 13.9989 13.9808 13.8049C13.9422 13.6109 13.847 13.4327 13.7071 13.2929C13.5673 13.153 13.3891 13.0578 13.1951 13.0192C13.0011 12.9806 12.8 13.0004 12.6173 13.0761C12.4346 13.1518 12.2784 13.28 12.1685 13.4444C12.0587 13.6089 12 13.8022 12 14C12 14.2652 12.1054 14.5196 12.2929 14.7071C12.4804 14.8946 12.7348 15 13 15ZM16 6C14.0222 6 12.0888 6.58649 10.4443 7.6853C8.79981 8.78412 7.51809 10.3459 6.76121 12.1732C6.00433 14.0004 5.8063 16.0111 6.19215 17.9509C6.578 19.8907 7.53041 21.6725 8.92894 23.0711C10.3275 24.4696 12.1093 25.422 14.0491 25.8079C15.9889 26.1937 17.9996 25.9957 19.8268 25.2388C21.6541 24.4819 23.2159 23.2002 24.3147 21.5557C25.4135 19.9112 26 17.9778 26 16C26 14.6868 25.7413 13.3864 25.2388 12.1732C24.7363 10.9599 23.9997 9.85752 23.0711 8.92893C22.1425 8.00035 21.0401 7.26375 19.8268 6.7612C18.6136 6.25866 17.3132 6 16 6ZM16 24C14.4178 24 12.871 23.5308 11.5554 22.6518C10.2398 21.7727 9.21447 20.5233 8.60897 19.0615C8.00347 17.5997 7.84504 15.9911 8.15372 14.4393C8.4624 12.8874 9.22433 11.462 10.3432 10.3431C11.462 9.22433 12.8874 8.4624 14.4393 8.15372C15.9911 7.84504 17.5997 8.00346 19.0615 8.60896C20.5233 9.21447 21.7727 10.2398 22.6518 11.5554C23.5308 12.871 24 14.4177 24 16C24 18.1217 23.1572 20.1566 21.6569 21.6569C20.1566 23.1571 18.1217 24 16 24ZM19 17H13C12.7348 17 12.4804 17.1054 12.2929 17.2929C12.1054 17.4804 12 17.7348 12 18C12 19.0609 12.4214 20.0783 13.1716 20.8284C13.9217 21.5786 14.9391 22 16 22C17.0609 22 18.0783 21.5786 18.8284 20.8284C19.5786 20.0783 20 19.0609 20 18C20 17.7348 19.8946 17.4804 19.7071 17.2929C19.5196 17.1054 19.2652 17 19 17ZM16 20C15.6493 19.9996 15.3048 19.9071 15.0012 19.7315C14.6975 19.556 14.4454 19.3037 14.27 19H17.73C17.5546 19.3037 17.3025 19.556 16.9988 19.7315C16.6952 19.9071 16.3507 19.9996 16 20ZM19 13C18.8022 13 18.6089 13.0586 18.4444 13.1685C18.28 13.2784 18.1518 13.4346 18.0761 13.6173C18.0004 13.8 17.9806 14.0011 18.0192 14.1951C18.0578 14.3891 18.153 14.5673 18.2929 14.7071C18.4328 14.847 18.6109 14.9422 18.8049 14.9808C18.9989 15.0194 19.2 14.9996 19.3827 14.9239C19.5654 14.8482 19.7216 14.72 19.8315 14.5556C19.9414 14.3911 20 14.1978 20 14C20 13.7348 19.8946 13.4804 19.7071 13.2929C19.5196 13.1054 19.2652 13 19 13Z"
          fill="#E7EAF3"
        />
      </g>
      <defs>
        <filter
          id="filter0_di"
          x="0"
          y="0"
          width="32"
          height="32"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0 0 0 0 0 0.66 0 0 0 1 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="0.2" dy="0.2" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0 0 0 0 0 0.36 0 0 0 1 0" />
          <feBlend mode="normal" in2="shape" result="effect2_innerShadow" />
        </filter>
      </defs>
    </svg>
  );
};
export const BackIcon = props => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M7.27266 12.2989L16.3122 21M16.7278 3L7.27256 12.1011"
        stroke="#E7EAF3"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const BackIconV2 = props => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M19 11H7.82998L12.71 6.11997C13.1 5.72997 13.1 5.08997 12.71 4.69997C12.32 4.30997 11.69 4.30997 11.3 4.69997L4.70998 11.29C4.31998 11.68 4.31998 12.31 4.70998 12.7L11.3 19.29C11.69 19.68 12.32 19.68 12.71 19.29C13.1 18.9 13.1 18.27 12.71 17.88L7.82998 13H19C19.55 13 20 12.55 20 12C20 11.45 19.55 11 19 11Z" fill="white"/>
</svg>

  );
};

export const NewBackIcon = props => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M16 7H3.83L9.42 1.41L8 0L0 8L8 16L9.41 14.59L3.83 9H16V7Z" fill="white" />
    </svg>
  );
};

export const SubscriptionIcon = props => {
  return (
    <svg width="18" height="25" viewBox="0 0 18 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M1.35223 22.0806L1.35517 22.0832L1.35813 22.0858C2.43719 23.0361 3.61807 23.731 4.9001 24.1445C6.15038 24.5478 7.54378 24.7383 9.06407 24.7383C10.5604 24.7383 11.9777 24.4614 13.3027 23.8979L13.3109 23.8945L13.319 23.8909C14.2688 23.4708 15.1818 22.6779 15.1818 22.6779L14.3713 21.7408C14.3713 21.7408 13.6686 22.3845 12.819 22.7603C11.656 23.2548 10.4044 23.502 9.06407 23.502C7.6449 23.502 6.38341 23.324 5.27961 22.9679C4.17581 22.6119 3.141 22.0086 2.17517 21.1581C1.64298 20.6833 1.37689 20.1592 1.37689 19.5856C1.37689 19.1306 1.54443 18.735 1.87951 18.3988C2.21459 18.0427 2.61866 17.8647 3.09172 17.8647C3.46623 17.8647 3.80131 17.9834 4.09697 18.2207C4.8854 18.8735 5.65412 19.3482 6.40313 19.6449C7.15213 19.9416 8.03912 20.0899 9.06407 20.0899C10.1679 20.0899 11.114 19.8427 11.9024 19.3482C12.7106 18.8537 13.1146 18.2405 13.1146 17.5087C13.1146 16.6186 12.7204 15.9263 11.932 15.4318C11.1436 14.9175 9.89192 14.5318 8.17709 14.2746C4.05213 13.6698 1.89806 11.8006 1.71488 8.66698H0.476881C0.567055 10.4632 1.21196 12.0077 2.47663 13.1898C3.8077 14.4341 5.70156 15.1608 7.99531 15.4974C9.65709 15.7467 10.6946 16.1006 11.2566 16.4672L11.2658 16.4732L11.2751 16.4791C11.7229 16.7599 11.8784 17.0671 11.8784 17.5087C11.8784 17.6832 11.8212 17.9485 11.2572 18.2937L11.2513 18.2973L11.2455 18.3009C10.688 18.6506 9.97927 18.8537 9.06407 18.8537C8.15434 18.8537 7.42897 18.7215 6.85842 18.4955C6.25765 18.2576 5.59951 17.8597 4.88535 17.2685L4.87818 17.2625L4.87091 17.2567C4.35875 16.8455 3.75146 16.6284 3.09172 16.6284C2.27103 16.6284 1.54956 16.9519 0.991357 17.5387C0.444387 18.0935 0.140625 18.794 0.140625 19.5856C0.140625 20.5944 0.626032 21.4328 1.35223 22.0806Z"
        fill="#36CFFF"
      />
      <path
        d="M16.3604 21.6263L15.5375 20.6748C15.5375 20.6748 16.6241 19.1752 16.6626 17.301C16.6626 15.9757 16.4063 14.9175 15.8938 14.1263C15.3814 13.3153 14.6126 12.6823 13.5877 12.2274C12.5824 11.7527 11.2323 11.367 9.53713 11.0703C8.03912 10.7933 6.93531 10.4373 6.22573 10.0021C5.53585 9.56697 5.19092 8.92412 5.19092 8.07358C5.19092 7.32194 5.526 6.71865 6.19616 6.26371C6.88604 5.78899 7.85186 5.55163 9.09364 5.55163C9.82294 5.55163 10.6409 5.72965 11.5476 6.08569C12.474 6.42195 13.1935 6.79777 13.706 7.21315C13.9425 7.39117 14.2086 7.48018 14.5042 7.48018C14.9576 7.48018 15.3518 7.31205 15.6869 6.97579C16.022 6.61975 16.1895 6.21426 16.1895 5.75932C16.1895 5.16592 15.9037 4.64175 15.3321 4.18681C14.6028 3.57362 13.6862 3.07912 12.5824 2.7033C11.4983 2.32748 10.3354 2.13957 9.09364 2.13957C7.71389 2.13957 6.46226 2.38682 5.33875 2.88132C4.21523 3.35604 3.32825 4.05823 2.6778 4.9879C2.09423 5.80421 1.77245 6.75585 1.71243 7.84281H0.474604C0.53622 6.52119 0.924149 5.31736 1.66843 4.27407C2.46017 3.14456 3.53398 2.30347 4.84909 1.74614C6.14568 1.17697 7.56699 0.90332 9.09364 0.90332C10.4607 0.90332 11.7604 1.11034 12.9841 1.53412C14.1945 1.94658 15.2488 2.50474 16.1154 3.23026C16.8992 3.85891 17.4258 4.70871 17.4258 5.75932C17.4258 6.55402 17.1204 7.25645 16.5871 7.82305L16.5751 7.8359L16.5626 7.84841C16.0077 8.40523 15.3031 8.71643 14.5042 8.71643C13.94 8.71643 13.4131 8.53998 12.9625 8.2009L12.9448 8.18753L12.9275 8.17354C12.5608 7.8763 11.9804 7.55794 11.1258 7.24775L11.1107 7.24227L11.0958 7.2364C10.2875 6.91901 9.62594 6.78788 9.09364 6.78788C7.98787 6.78788 7.30322 7.00259 6.89698 7.28213L6.89376 7.28435L6.89053 7.28654C6.5282 7.53251 6.42718 7.76784 6.42718 8.07358C6.42718 8.51865 6.57064 8.75607 6.879 8.95253C7.39353 9.26589 8.31443 9.58664 9.75628 9.85357C11.4985 10.1589 12.9616 10.5667 14.1026 11.1034C15.3041 11.6392 16.2736 12.4159 16.9352 13.46C17.6172 14.5162 17.8988 15.8327 17.8988 17.301C17.8988 19.5872 16.3604 21.6263 16.3604 21.6263Z"
        fill="#36CFFF"
      />
    </svg>
  );
};
export const MasterCardLogo = props => {
  return (
    <svg width="48" height="32" viewBox="0 0 48 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="48" height="32" rx="2" fill="white" />
      <path d="M27.5072 9.71118H20.4712V22.2885H27.5072V9.71118Z" fill="#FF5A00" />
      <path d="M20.94 16C20.94 13.4447 22.1473 11.1767 24 9.71133C22.6365 8.64466 20.9165 8 19.0404 8C14.5961 8 11 11.578 11 16C11 20.422 14.5961 24 19.0404 24C20.9165 24 22.6365 23.3553 24 22.2887C22.1447 20.844 20.94 18.5553 20.94 16Z" fill="#EB001B" />
      <path d="M37 16C37 20.422 33.4039 24 28.9596 24C27.0835 24 25.3635 23.3553 24 22.2887C25.8761 20.8207 27.06 18.5553 27.06 16C27.06 13.4447 25.8527 11.1767 24 9.71133C25.3609 8.64466 27.0809 8 28.957 8C33.4039 8 37 11.6013 37 16Z" fill="#F79E1B" />
    </svg>

  );
};
export const AmexLogo = props => {
  return (
    <svg width="48" height="32" viewBox="0 0 48 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="48" height="32" rx="2" fill="white" />
      <path d="M14.3098 22V16.8059H19.8094L20.3994 17.5751L21.009 16.8059H40.9709V21.6418C40.9709 21.6418 40.4489 21.9948 39.8451 22H28.7918L28.1265 21.1812V22H25.9466V20.6023C25.9466 20.6023 25.6488 20.7974 25.005 20.7974H24.263V22H20.9623L20.3731 21.2143L19.7749 22H14.3098Z" fill="#016FD0" />
      <path d="M7.88679 12.8913L9.12696 10H11.2717L11.9755 11.6196V10H14.6416L15.0606 11.1706L15.4668 10H27.4349V10.5885C27.4349 10.5885 28.064 10 29.098 10L32.9812 10.0136L33.6729 11.6119V10H35.904L36.5181 10.9181V10H38.7697V15.1941H36.5181L35.9296 14.2729V15.1941H32.6515L32.3219 14.3753H31.4406L31.1164 15.1941H28.8933C28.0036 15.1941 27.4349 14.6176 27.4349 14.6176V15.1941H24.083L23.4178 14.3753V15.1941H10.954L10.6245 14.3753H9.74611L9.41901 15.1941H6.94727L7.88679 12.8913Z" fill="#016FD0" />
      <path d="M9.56456 10.6403L7.89185 14.5294H8.98087L9.28951 13.7506H11.0838L11.3908 14.5294H12.5038L10.8327 10.6403H9.56456ZM10.1834 11.5454L10.7303 12.9063H9.63493L10.1834 11.5454Z" fill="white" />
      <path d="M12.6194 14.5288V10.6396L14.1669 10.6454L15.0671 13.1529L15.9456 10.6396H17.4808V14.5288H16.5085V11.6631L15.4779 14.5288H14.6252L13.5917 11.6631V14.5288H12.6194Z" fill="white" />
      <path d="M18.1475 14.5288V10.6396H21.3202V11.5096H19.13V12.1748H21.269V12.9936H19.13V13.6844H21.3202V14.5288H18.1475Z" fill="white" />
      <path d="M21.8818 10.6403V14.5294H22.8541V13.1477H23.2635L24.4293 14.5294H25.6175L24.3381 13.0966C24.8632 13.0523 25.4048 12.6016 25.4048 11.902C25.4048 11.0836 24.7624 10.6403 24.0455 10.6403H21.8818ZM22.8541 11.5102H23.9655C24.2321 11.5102 24.4261 11.7188 24.4261 11.9196C24.4261 12.178 24.1748 12.329 23.9799 12.329H22.8541V11.5102Z" fill="white" />
      <path d="M26.7943 14.5288H25.8015V10.6396H26.7943V14.5288Z" fill="white" />
      <path d="M29.1494 14.5288H28.9351C27.8983 14.5288 27.2688 13.712 27.2688 12.6002C27.2688 11.461 27.8913 10.6396 29.2006 10.6396H30.2752V11.5608H29.1613C28.6298 11.5608 28.2539 11.9756 28.2539 12.6098C28.2539 13.363 28.6837 13.6793 29.3029 13.6793H29.5588L29.1494 14.5288Z" fill="white" />
      <path d="M31.2643 10.6403L29.5916 14.5294H30.6806L30.9892 13.7506H32.7835L33.0905 14.5294H34.2035L32.5324 10.6403H31.2643ZM31.8831 11.5454L32.4301 12.9063H31.3346L31.8831 11.5454Z" fill="white" />
      <path d="M34.3174 14.5288V10.6396H35.5535L37.1319 13.0832V10.6396H38.1042V14.5288H36.908L35.2897 12.0213V14.5288H34.3174Z" fill="white" />
      <path d="M14.9751 21.3348V17.4457H18.1478V18.3156H15.9576V18.9809H18.0967V19.7996H15.9576V20.4905H18.1478V21.3348H14.9751Z" fill="white" />
      <path d="M30.5205 21.3348V17.4457H33.6932V18.3156H31.503V18.9809H33.6318V19.7996H31.503V20.4905H33.6932V21.3348H30.5205Z" fill="white" />
      <path d="M18.2704 21.3348L19.8152 19.4142L18.2336 17.4457H19.4586L20.4005 18.6626L21.3456 17.4457H22.5226L20.9618 19.3903L22.5094 21.3348H21.2847L20.3701 20.1371L19.4778 21.3348H18.2704Z" fill="white" />
      <path d="M22.6245 17.4465V21.3357H23.6224V20.1075H24.6458C25.5118 20.1075 26.1682 19.6481 26.1682 18.7546C26.1682 18.0145 25.6534 17.4465 24.7722 17.4465H22.6245ZM23.6224 18.3261H24.7002C24.98 18.3261 25.18 18.4975 25.18 18.7738C25.18 19.0334 24.981 19.2216 24.697 19.2216H23.6224V18.3261Z" fill="white" />
      <path d="M26.5903 17.4457V21.3348H27.5626V19.9532H27.972L29.1378 21.3348H30.326L29.0466 19.902C29.5717 19.8577 30.1133 19.407 30.1133 18.7074C30.1133 17.889 29.4709 17.4457 28.754 17.4457H26.5903ZM27.5626 18.3156H28.674C28.9406 18.3156 29.1346 18.5242 29.1346 18.725C29.1346 18.9834 28.8833 19.1344 28.6884 19.1344H27.5626V18.3156Z" fill="white" />
      <path d="M34.1435 21.3348V20.4905H36.0893C36.3772 20.4905 36.5019 20.3349 36.5019 20.1642C36.5019 20.0008 36.3776 19.8355 36.0893 19.8355H35.21C34.4457 19.8355 34.02 19.3698 34.02 18.6706C34.02 18.047 34.4098 17.4457 35.5456 17.4457H37.439L37.0296 18.3207H35.3921C35.0791 18.3207 34.9827 18.485 34.9827 18.6418C34.9827 18.8031 35.1018 18.9809 35.3409 18.9809H36.262C37.1141 18.9809 37.4838 19.4642 37.4838 20.0971C37.4838 20.7775 37.0718 21.3348 36.2157 21.3348H34.1435Z" fill="white" />
      <path d="M37.7121 21.3348V20.4905H39.6579C39.9458 20.4905 40.0705 20.3349 40.0705 20.1642C40.0705 20.0008 39.9462 19.8355 39.6579 19.8355H38.7786C38.0143 19.8355 37.5886 19.3698 37.5886 18.6706C37.5886 18.047 37.9784 17.4457 39.1142 17.4457H41.0076L40.5982 18.3207H38.9607C38.6477 18.3207 38.5513 18.485 38.5513 18.6418C38.5513 18.8031 38.6704 18.9809 38.9095 18.9809H39.8306C40.6827 18.9809 41.0524 19.4642 41.0524 20.0971C41.0524 20.7775 40.6404 21.3348 39.7843 21.3348H37.7121Z" fill="white" />
    </svg>

  );
};
export const VisaLogo = props => {
  return (
    <svg width="48" height="32" viewBox="0 0 48 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="48" height="32" rx="2" fill="white" />
      <path d="M21.9395 21.3558H19.4365L21.0021 11.6755H23.505L21.9395 21.3558Z" fill="#00579F" />
      <path d="M31.0132 11.9121C30.5195 11.7163 29.7364 11.5 28.7682 11.5C26.2964 11.5 24.5558 12.8181 24.5451 14.7026C24.5246 16.0929 25.7913 16.8652 26.7388 17.3288C27.7072 17.8025 28.0363 18.1117 28.0363 18.5339C28.0265 19.1825 27.2538 19.4814 26.5332 19.4814C25.5339 19.4814 24.9984 19.3273 24.1847 18.9665L23.8551 18.8118L23.5049 20.9848C24.0919 21.2523 25.1735 21.4896 26.2964 21.5C28.9227 21.5 30.6325 20.2023 30.6528 18.1941C30.6628 17.0921 29.9939 16.2477 28.5518 15.5578C27.6764 15.1148 27.1402 14.8162 27.1402 14.363C27.1505 13.951 27.5937 13.529 28.5819 13.529C29.3956 13.5083 29.9935 13.7039 30.4464 13.8997L30.6728 14.0025L31.0132 11.9121Z" fill="#00579F" />
      <path d="M34.3408 17.9264C34.547 17.3703 35.3401 15.218 35.3401 15.218C35.3297 15.2386 35.5459 14.6516 35.6695 14.2912L35.8444 15.1253C35.8444 15.1253 36.3184 17.4424 36.4213 17.9264C36.0301 17.9264 34.8352 17.9264 34.3408 17.9264ZM37.4305 11.6755H35.4944C34.8974 11.6755 34.4438 11.8505 34.1862 12.4787L30.4683 21.3557H33.0946C33.0946 21.3557 33.527 20.1609 33.6199 19.9036C33.908 19.9036 36.4629 19.9036 36.8336 19.9036C36.9054 20.2434 37.1322 21.3557 37.1322 21.3557H39.4498L37.4305 11.6755Z" fill="#00579F" />
      <path d="M17.3462 11.6755L14.8949 18.2765L14.6271 16.9378C14.1739 15.393 12.7526 13.7147 11.1665 12.8802L13.4118 21.3455H16.0586L19.9929 11.6755H17.3462Z" fill="#00579F" />
      <path d="M12.6186 11.6755H8.59149L8.55029 11.8711C11.6917 12.6744 13.7722 14.6108 14.6269 16.9382L13.7515 12.4893C13.6074 11.871 13.1644 11.6959 12.6186 11.6755Z" fill="#FAA61A" />
    </svg>

  );
};

export const VisaIcon = props => {
  return (
    <svg width="36" height="24" viewBox="0 0 36 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect y="0.763672" width="36.0003" height="22.4728" rx="2" fill="white" />
      <path d="M16.6665 15.1431H15.0464L16.0597 8.87732H17.6798L16.6665 15.1431Z" fill="#00579F" />
      <path d="M22.5396 9.03043C22.2201 8.90365 21.7132 8.76367 21.0865 8.76367C19.4866 8.76367 18.3599 9.61684 18.353 10.8366C18.3397 11.7366 19.1597 12.2364 19.7729 12.5365C20.3997 12.8431 20.6128 13.0433 20.6128 13.3166C20.6064 13.7363 20.1063 13.9298 19.6398 13.9298C18.993 13.9298 18.6464 13.8301 18.1197 13.5965L17.9064 13.4964L17.6797 14.903C18.0597 15.0761 18.7597 15.2297 19.4866 15.2364C21.1865 15.2364 22.2933 14.3965 22.3064 13.0966C22.3128 12.3833 21.8799 11.8368 20.9464 11.3902C20.3798 11.1035 20.0328 10.9102 20.0328 10.6168C20.0394 10.3501 20.3263 10.077 20.9659 10.077C21.4926 10.0636 21.8796 10.1902 22.1728 10.3169L22.3193 10.3835L22.5396 9.03043Z" fill="#00579F" />
      <path d="M24.6936 12.9234C24.8271 12.5634 25.3405 11.1703 25.3405 11.1703C25.3337 11.1836 25.4736 10.8036 25.5536 10.5704L25.6669 11.1103C25.6669 11.1103 25.9737 12.6101 26.0403 12.9234C25.7871 12.9234 25.0136 12.9234 24.6936 12.9234ZM26.6935 8.87732H25.4403C25.0539 8.87732 24.7603 8.99054 24.5935 9.3972L22.187 15.143H23.887C23.887 15.143 24.1668 14.3697 24.227 14.2031C24.4135 14.2031 26.0672 14.2031 26.3071 14.2031C26.3536 14.4231 26.5004 15.143 26.5004 15.143H28.0005L26.6935 8.87732Z" fill="#00579F" />
      <path d="M13.6933 8.87732L12.1067 13.15L11.9333 12.2835C11.64 11.2836 10.72 10.1972 9.69336 9.65705L11.1467 15.1365H12.8599L15.4065 8.87732H13.6933Z" fill="#00579F" />
      <path d="M10.6333 8.87732H8.02667L8 9.00392C10.0333 9.52389 11.38 10.7772 11.9333 12.2837L11.3666 9.40402C11.2733 9.00383 10.9866 8.89052 10.6333 8.87732Z" fill="#FAA61A" />
    </svg>


  );
};
export const MastercardIcon = props => {
  return (
  
<svg width="36" height="24" viewBox="0 0 36 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="36" height="24" rx="2" fill="#F4F4F4"/>
<path d="M20.698 7.28345H15.2856V16.7165H20.698V7.28345Z" fill="#FF5A00"/>
<path d="M15.6461 12C15.6461 10.0835 16.5749 8.38252 18 7.2835C16.9512 6.4835 15.6281 6 14.1849 6C10.7662 6 8 8.6835 8 12C8 15.3165 10.7662 18 14.1849 18C15.6281 18 16.9512 17.5165 18 16.7165C16.5729 15.633 15.6461 13.9165 15.6461 12Z" fill="#EB001B"/>
<path d="M28 12C28 15.3165 25.2338 18 21.8151 18C20.3719 18 19.0488 17.5165 18 16.7165C19.4432 15.6155 20.3539 13.9165 20.3539 12C20.3539 10.0835 19.4251 8.38252 18 7.2835C19.0468 6.4835 20.3699 6 21.813 6C25.2338 6 28 8.70097 28 12Z" fill="#F79E1B"/>
</svg>


  );
};
export const AmexIcon = props => {
  return (
    <svg width="48" height="32" viewBox="0 0 48 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="48" height="32" rx="2" fill="white"/>
    <path d="M14.3101 22V16.8059H19.8096L20.3996 17.5751L21.0092 16.8059H40.9712V21.6418C40.9712 21.6418 40.4491 21.9948 39.8454 22H28.792L28.1268 21.1812V22H25.9468V20.6023C25.9468 20.6023 25.649 20.7974 25.0052 20.7974H24.2632V22H20.9625L20.3733 21.2143L19.7751 22H14.3101Z" fill="#016FD0"/>
    <path d="M7.88679 12.8913L9.12696 10H11.2717L11.9755 11.6196V10H14.6416L15.0606 11.1706L15.4668 10H27.4349V10.5885C27.4349 10.5885 28.064 10 29.098 10L32.9812 10.0136L33.6729 11.6119V10H35.904L36.5181 10.9181V10H38.7697V15.1941H36.5181L35.9296 14.2729V15.1941H32.6515L32.3219 14.3753H31.4406L31.1164 15.1941H28.8933C28.0036 15.1941 27.4349 14.6176 27.4349 14.6176V15.1941H24.083L23.4178 14.3753V15.1941H10.954L10.6245 14.3753H9.74611L9.41901 15.1941H6.94727L7.88679 12.8913Z" fill="#016FD0"/>
    <path d="M9.56432 10.6403L7.8916 14.5294H8.98063L9.28926 13.7506H11.0835L11.3906 14.5294H12.5036L10.8324 10.6403H9.56432ZM10.1832 11.5454L10.7301 12.9063H9.63468L10.1832 11.5454Z" fill="white"/>
    <path d="M12.6191 14.5288V10.6396L14.1667 10.6454L15.0668 13.1529L15.9454 10.6396H17.4806V14.5288H16.5083V11.6631L15.4776 14.5288H14.6249L13.5914 11.6631V14.5288H12.6191Z" fill="white"/>
    <path d="M18.1475 14.5288V10.6396H21.3202V11.5096H19.13V12.1748H21.269V12.9936H19.13V13.6844H21.3202V14.5288H18.1475Z" fill="white"/>
    <path d="M21.8818 10.6403V14.5294H22.8541V13.1477H23.2635L24.4293 14.5294H25.6175L24.3381 13.0966C24.8632 13.0523 25.4048 12.6016 25.4048 11.902C25.4048 11.0836 24.7624 10.6403 24.0455 10.6403H21.8818ZM22.8541 11.5102H23.9655C24.2321 11.5102 24.4261 11.7188 24.4261 11.9196C24.4261 12.178 24.1748 12.329 23.9799 12.329H22.8541V11.5102Z" fill="white"/>
    <path d="M26.794 14.5288H25.8013V10.6396H26.794V14.5288Z" fill="white"/>
    <path d="M29.1497 14.5288H28.9354C27.8985 14.5288 27.269 13.712 27.269 12.6002C27.269 11.461 27.8915 10.6396 29.2008 10.6396H30.2755V11.5608H29.1615C28.63 11.5608 28.2541 11.9756 28.2541 12.6098C28.2541 13.363 28.6839 13.6793 29.3032 13.6793H29.559L29.1497 14.5288Z" fill="white"/>
    <path d="M31.2645 10.6403L29.5918 14.5294H30.6808L30.9895 13.7506H32.7837L33.0907 14.5294H34.2038L32.5326 10.6403H31.2645ZM31.8834 11.5454L32.4303 12.9063H31.3349L31.8834 11.5454Z" fill="white"/>
    <path d="M34.3174 14.5288V10.6396H35.5535L37.1319 13.0832V10.6396H38.1042V14.5288H36.908L35.2897 12.0213V14.5288H34.3174Z" fill="white"/>
    <path d="M14.9751 21.3348V17.4457H18.1478V18.3156H15.9576V18.9809H18.0967V19.7996H15.9576V20.4905H18.1478V21.3348H14.9751Z" fill="white"/>
    <path d="M30.5205 21.3348V17.4457H33.6932V18.3156H31.503V18.9809H33.6318V19.7996H31.503V20.4905H33.6932V21.3348H30.5205Z" fill="white"/>
    <path d="M18.2702 21.3348L19.815 19.4142L18.2334 17.4457H19.4584L20.4003 18.6626L21.3454 17.4457H22.5223L20.9616 19.3903L22.5092 21.3348H21.2844L20.3699 20.1371L19.4775 21.3348H18.2702Z" fill="white"/>
    <path d="M22.6245 17.4465V21.3357H23.6224V20.1075H24.6458C25.5118 20.1075 26.1682 19.6481 26.1682 18.7546C26.1682 18.0145 25.6534 17.4465 24.7722 17.4465H22.6245ZM23.6224 18.3261H24.7002C24.98 18.3261 25.18 18.4975 25.18 18.7738C25.18 19.0334 24.981 19.2216 24.697 19.2216H23.6224V18.3261Z" fill="white"/>
    <path d="M26.5903 17.4457V21.3348H27.5626V19.9532H27.972L29.1378 21.3348H30.326L29.0466 19.902C29.5717 19.8577 30.1133 19.407 30.1133 18.7074C30.1133 17.889 29.4709 17.4457 28.754 17.4457H26.5903ZM27.5626 18.3156H28.674C28.9406 18.3156 29.1346 18.5242 29.1346 18.725C29.1346 18.9834 28.8833 19.1344 28.6884 19.1344H27.5626V18.3156Z" fill="white"/>
    <path d="M34.1435 21.3348V20.4905H36.0893C36.3772 20.4905 36.5019 20.3349 36.5019 20.1642C36.5019 20.0008 36.3776 19.8355 36.0893 19.8355H35.21C34.4457 19.8355 34.02 19.3698 34.02 18.6706C34.02 18.047 34.4098 17.4457 35.5456 17.4457H37.439L37.0296 18.3207H35.3921C35.0791 18.3207 34.9827 18.485 34.9827 18.6418C34.9827 18.8031 35.1018 18.9809 35.3409 18.9809H36.262C37.1141 18.9809 37.4838 19.4642 37.4838 20.0971C37.4838 20.7775 37.0718 21.3348 36.2157 21.3348H34.1435Z" fill="white"/>
    <path d="M37.7123 21.3348V20.4905H39.6582C39.9461 20.4905 40.0708 20.3349 40.0708 20.1642C40.0708 20.0008 39.9465 19.8355 39.6582 19.8355H38.7789C38.0145 19.8355 37.5889 19.3698 37.5889 18.6706C37.5889 18.047 37.9787 17.4457 39.1145 17.4457H41.0079L40.5985 18.3207H38.9609C38.6479 18.3207 38.5516 18.485 38.5516 18.6418C38.5516 18.8031 38.6706 18.9809 38.9098 18.9809H39.8309C40.6829 18.9809 41.0526 19.4642 41.0526 20.0971C41.0526 20.7775 40.6407 21.3348 39.7845 21.3348H37.7123Z" fill="white"/>
    </svg>
    


  );
};
export const DinerIcon = props => {
  return (
    <svg width="48" height="32" viewBox="0 0 48 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="48" height="32" rx="2" fill="white" />
      <path d="M25.7165 23.9223C30.0471 23.943 33.9997 20.3905 33.9997 16.0688C33.9997 11.3428 30.0471 8.07607 25.7165 8.07764H21.9896C17.6072 8.07607 14 11.3437 14 16.0688C14 20.3915 17.6072 23.943 21.9896 23.9223H25.7165Z" fill="#0079BE" />
      <path d="M22.0068 8.73291C18.0023 8.73417 14.7573 11.9801 14.7563 15.9863C14.7573 19.9917 18.0023 23.2373 22.0068 23.2386C26.0123 23.2373 29.258 19.9917 29.2585 15.9863C29.258 11.9801 26.0123 8.73417 22.0068 8.73291ZM17.411 15.9863C17.4147 14.0286 18.6373 12.3593 20.3614 11.6959V20.2756C18.6373 19.6126 17.4147 17.9442 17.411 15.9863ZM23.6517 20.2775V11.6956C25.3763 12.3574 26.6008 14.0277 26.604 15.9863C26.6008 17.9454 25.3763 19.6145 23.6517 20.2775Z" fill="white" />
      <path d="M25.7165 23.9223C30.0471 23.943 33.9997 20.3905 33.9997 16.0688C33.9997 11.3428 30.0471 8.07607 25.7165 8.07764H21.9896C17.6072 8.07607 14 11.3437 14 16.0688C14 20.3915 17.6072 23.943 21.9896 23.9223H25.7165Z" fill="#0079BE" />
      <path d="M22.0068 8.73291C18.0023 8.73417 14.7573 11.9801 14.7563 15.9863C14.7573 19.9917 18.0023 23.2373 22.0068 23.2386C26.0123 23.2373 29.258 19.9917 29.2585 15.9863C29.258 11.9801 26.0123 8.73417 22.0068 8.73291ZM17.411 15.9863C17.4147 14.0286 18.6373 12.3593 20.3614 11.6959V20.2756C18.6373 19.6126 17.4147 17.9442 17.411 15.9863ZM23.6517 20.2775V11.6956C25.3763 12.3574 26.6008 14.0277 26.604 15.9863C26.6008 17.9454 25.3763 19.6145 23.6517 20.2775Z" fill="white" />
    </svg>




  );
};
export const JsbIcon = props => {
  return (
    <svg width="48" height="32" viewBox="0 0 48 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="48" height="32" rx="2" fill="white" />
      <path d="M35.0003 21.0563C35.0003 22.9389 33.4673 24.472 31.5846 24.472H13V10.9437C13 9.06098 14.533 7.52795 16.4157 7.52795H35.0003V21.0563Z" fill="white" />
      <path d="M28.9482 17.5865H30.3602C30.4006 17.5865 30.4947 17.5731 30.5351 17.5731C30.804 17.5193 31.0326 17.2772 31.0326 16.941C31.0326 16.6183 30.804 16.3762 30.5351 16.309C30.4947 16.2955 30.414 16.2955 30.3602 16.2955H28.9482V17.5865Z" fill="url(#paint0_linear)" />
      <path d="M30.2007 8.67126C28.8559 8.67126 27.7532 9.76052 27.7532 11.1187V13.6603H31.2092C31.2899 13.6603 31.3841 13.6603 31.4513 13.6738C32.2313 13.7141 32.8095 14.1176 32.8095 14.8168C32.8095 15.3682 32.4195 15.8389 31.6933 15.933V15.9599C32.4868 16.0137 33.0919 16.4574 33.0919 17.1433C33.0919 17.8829 32.4195 18.367 31.532 18.367H27.7397V23.3426H31.3303C32.675 23.3426 33.7777 22.2534 33.7777 20.8952V8.67126H30.2007Z" fill="url(#paint1_linear)" />
      <path d="M30.8578 14.9777C30.8578 14.6549 30.6292 14.4398 30.3602 14.3994C30.3333 14.3994 30.2661 14.386 30.2258 14.386H28.9482V15.5694H30.2258C30.2661 15.5694 30.3468 15.5694 30.3602 15.5559C30.6292 15.5156 30.8578 15.3004 30.8578 14.9777Z" fill="url(#paint2_linear)" />
      <path d="M16.6719 8.67126C15.3271 8.67126 14.2244 9.76052 14.2244 11.1187V17.1567C14.9102 17.4929 15.6229 17.7081 16.3357 17.7081C17.1829 17.7081 17.6401 17.1971 17.6401 16.4978V13.6469H19.7379V16.4843C19.7379 17.587 19.0521 18.488 16.7256 18.488C15.3136 18.488 14.2109 18.1787 14.2109 18.1787V23.3292H17.8015C19.1462 23.3292 20.2489 22.2399 20.2489 20.8817V8.67126H16.6719Z" fill="url(#paint3_linear)" />
      <path d="M23.4358 8.67126C22.091 8.67126 20.9883 9.76052 20.9883 11.1187V14.3193C21.6069 13.7948 22.6827 13.4586 24.4174 13.5393C25.3453 13.5797 26.3404 13.8352 26.3404 13.8352V14.8706C25.8429 14.6151 25.2512 14.3865 24.4847 14.3327C23.1668 14.2386 22.3734 14.8841 22.3734 16.0137C22.3734 17.1567 23.1668 17.8022 24.4847 17.6946C25.2512 17.6408 25.8429 17.3988 26.3404 17.1567V18.1922C26.3404 18.1922 25.3588 18.4477 24.4174 18.488C22.6827 18.5687 21.6069 18.2325 20.9883 17.7081V23.3561H24.5788C25.9236 23.3561 27.0263 22.2668 27.0263 20.9086V8.67126H23.4358Z" fill="url(#paint4_linear)" />
      <defs>
        <linearGradient id="paint0_linear" x1="27.7492" y1="16.9426" x2="33.7922" y2="16.9426" gradientUnits="userSpaceOnUse">
          <stop stop-color="#007940" />
          <stop offset="0.2285" stop-color="#00873F" />
          <stop offset="0.7433" stop-color="#40A737" />
          <stop offset="1" stop-color="#5CB531" />
        </linearGradient>
        <linearGradient id="paint1_linear" x1="27.7508" y1="16.0011" x2="33.7942" y2="16.0011" gradientUnits="userSpaceOnUse">
          <stop stop-color="#007940" />
          <stop offset="0.2285" stop-color="#00873F" />
          <stop offset="0.7433" stop-color="#40A737" />
          <stop offset="1" stop-color="#5CB531" />
        </linearGradient>
        <linearGradient id="paint2_linear" x1="27.749" y1="14.976" x2="33.7923" y2="14.976" gradientUnits="userSpaceOnUse">
          <stop stop-color="#007940" />
          <stop offset="0.2285" stop-color="#00873F" />
          <stop offset="0.7433" stop-color="#40A737" />
          <stop offset="1" stop-color="#5CB531" />
        </linearGradient>
        <linearGradient id="paint3_linear" x1="14.2215" y1="16.0011" x2="20.3581" y2="16.0011" gradientUnits="userSpaceOnUse">
          <stop stop-color="#1F286F" />
          <stop offset="0.4751" stop-color="#004E94" />
          <stop offset="0.8261" stop-color="#0066B1" />
          <stop offset="1" stop-color="#006FBC" />
        </linearGradient>
        <linearGradient id="paint4_linear" x1="20.9535" y1="16.0011" x2="26.9135" y2="16.0011" gradientUnits="userSpaceOnUse">
          <stop stop-color="#6C2C2F" />
          <stop offset="0.1735" stop-color="#882730" />
          <stop offset="0.5731" stop-color="#BE1833" />
          <stop offset="0.8585" stop-color="#DC0436" />
          <stop offset="1" stop-color="#E60039" />
        </linearGradient>
      </defs>
    </svg>





  );
};
export const DiscoverIcon = props => {
  return (
    <svg width="48" height="32" viewBox="0 0 48 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="48" height="32" rx="2" fill="white" />
      <path d="M7.25466 17.5369C6.86672 17.8872 6.3628 18.04 5.56504 18.04H5.23368V13.8543H5.56504C6.3628 13.8543 6.84689 13.9971 7.25466 14.3662C7.68165 14.7465 7.93853 15.3356 7.93853 15.942C7.93853 16.5496 7.68165 17.1568 7.25466 17.5369ZM5.81236 12.7819H4V19.1116H5.8028C6.76145 19.1116 7.45364 18.8854 8.06128 18.3809C8.78331 17.7833 9.2103 16.8827 9.2103 15.9511C9.2103 14.0832 7.81467 12.7819 5.81236 12.7819Z" fill="#201D1C" />
      <path d="M9.77832 19.1116H11.013V12.7819H9.77832V19.1116Z" fill="#201D1C" />
      <path d="M14.0325 15.2108C13.2916 14.9366 13.074 14.7558 13.074 14.4138C13.074 14.0152 13.4616 13.7122 13.9938 13.7122C14.3637 13.7122 14.6678 13.8642 14.9895 14.2248L15.6354 13.3789C15.1046 12.9146 14.4694 12.6771 13.7754 12.6771C12.6555 12.6771 11.8013 13.4549 11.8013 14.4908C11.8013 15.3629 12.199 15.8094 13.3586 16.2267C13.8419 16.3972 14.0879 16.5107 14.2121 16.5872C14.4588 16.7483 14.5823 16.9763 14.5823 17.2421C14.5823 17.755 14.1745 18.135 13.6236 18.135C13.0348 18.135 12.5604 17.8404 12.2762 17.2907L11.4785 18.0587C12.0474 18.8937 12.7305 19.2638 13.67 19.2638C14.9531 19.2638 15.8531 18.4107 15.8531 17.1853C15.8531 16.1797 15.437 15.7244 14.0325 15.2108Z" fill="#201D1C" />
      <path d="M16.2422 15.9511C16.2422 17.8116 17.7031 19.2543 19.5832 19.2543C20.1147 19.2543 20.5698 19.1498 21.1311 18.8854V17.432C20.6376 17.926 20.2004 18.1252 19.6406 18.1252C18.3972 18.1252 17.5146 17.2237 17.5146 15.942C17.5146 14.7267 18.425 13.768 19.5832 13.768C20.1721 13.768 20.6178 13.9782 21.1311 14.4802V13.0276C20.5892 12.7526 20.1435 12.6388 19.6123 12.6388C17.7418 12.6388 16.2422 14.1106 16.2422 15.9511Z" fill="#201D1C" />
      <path d="M30.921 17.0335L29.2331 12.7819H27.8843L30.5703 19.2739H31.2347L33.9693 12.7819H32.6309L30.921 17.0335Z" fill="#201D1C" />
      <path d="M34.5273 19.1116H38.0288V18.04H35.761V16.3314H37.9451V15.2593H35.761V13.8543H38.0288V12.7819H34.5273V19.1116Z" fill="#201D1C" />
      <path d="M40.4405 15.696H40.0799V13.7789H40.46C41.229 13.7789 41.647 14.101 41.647 14.7171C41.647 15.3534 41.229 15.696 40.4405 15.696ZM42.9176 14.6506C42.9176 13.4656 42.1013 12.7819 40.6774 12.7819H38.8467V19.1116H40.0799V16.5688H40.2408L41.9498 19.1116H43.4682L41.4756 16.445C42.4055 16.2559 42.9176 15.6198 42.9176 14.6506Z" fill="#201D1C" />
      <path d="M43.4712 13.0958H43.4488V12.9504H43.4726C43.5383 12.9504 43.5723 12.974 43.5723 13.0219C43.5723 13.0712 43.5378 13.0958 43.4712 13.0958ZM43.7051 13.0199C43.7051 12.909 43.6287 12.8483 43.4945 12.8483H43.3159V13.4047H43.4488V13.1889L43.6045 13.4047H43.7666L43.5836 13.1752C43.6618 13.1541 43.7051 13.0971 43.7051 13.0199Z" fill="#201D1C" />
      <path d="M43.5195 13.5237C43.3068 13.5237 43.133 13.3467 43.133 13.126C43.133 12.9044 43.3046 12.7276 43.5195 12.7276C43.731 12.7276 43.9035 12.9085 43.9035 13.126C43.9035 13.3449 43.731 13.5237 43.5195 13.5237ZM43.5213 12.6403C43.2511 12.6403 43.0366 12.8559 43.0366 13.1253C43.0366 13.3945 43.2536 13.6104 43.5213 13.6104C43.7845 13.6104 44 13.3922 44 13.1253C44 12.8597 43.7845 12.6403 43.5213 12.6403Z" fill="#201D1C" />
      <circle cx="24.8114" cy="16" r="3.46863" fill="url(#paint0_linear)" />
      <defs>
        <linearGradient id="paint0_linear" x1="22.2888" y1="13.0044" x2="27.0187" y2="18.6803" gradientUnits="userSpaceOnUse">
          <stop stop-color="#D43C21" />
          <stop offset="1" stop-color="#F59314" />
        </linearGradient>
      </defs>
    </svg>




  );
};
export const SubscriptionIconPersonal = props => {
  return (
    <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_di)">
    <path d="M20.3522 37.0806L20.3552 37.0832L20.3581 37.0858C21.4372 38.0361 22.6181 38.731 23.9001 39.1445C25.1504 39.5478 26.5438 39.7383 28.0641 39.7383C29.5604 39.7383 30.9777 39.4614 32.3027 38.8979L32.3109 38.8945L32.319 38.8909C33.2688 38.4708 34.1818 37.6779 34.1818 37.6779L33.3713 36.7408C33.3713 36.7408 32.6686 37.3845 31.819 37.7603C30.656 38.2548 29.4044 38.502 28.0641 38.502C26.6449 38.502 25.3834 38.324 24.2796 37.9679C23.1758 37.6119 22.141 37.0086 21.1752 36.1581C20.643 35.6833 20.3769 35.1592 20.3769 34.5856C20.3769 34.1306 20.5444 33.735 20.8795 33.3988C21.2146 33.0427 21.6187 32.8647 22.0917 32.8647C22.4662 32.8647 22.8013 32.9834 23.097 33.2207C23.8854 33.8735 24.6541 34.3482 25.4031 34.6449C26.1521 34.9416 27.0391 35.0899 28.0641 35.0899C29.1679 35.0899 30.114 34.8427 30.9024 34.3482C31.7106 33.8537 32.1146 33.2405 32.1146 32.5087C32.1146 31.6186 31.7204 30.9263 30.932 30.4318C30.1436 29.9175 28.8919 29.5318 27.1771 29.2746C23.0521 28.6698 20.8981 26.8006 20.7149 23.667H19.4769C19.5671 25.4632 20.212 27.0077 21.4766 28.1898C22.8077 29.4341 24.7016 30.1608 26.9953 30.4974C28.6571 30.7467 29.6946 31.1006 30.2566 31.4672L30.2658 31.4732L30.2751 31.4791C30.7229 31.7599 30.8784 32.0671 30.8784 32.5087C30.8784 32.6832 30.8212 32.9485 30.2572 33.2937L30.2513 33.2973L30.2455 33.3009C29.688 33.6506 28.9793 33.8537 28.0641 33.8537C27.1543 33.8537 26.429 33.7215 25.8584 33.4955C25.2577 33.2576 24.5995 32.8597 23.8854 32.2685L23.8782 32.2625L23.8709 32.2567C23.3587 31.8455 22.7515 31.6284 22.0917 31.6284C21.271 31.6284 20.5496 31.9519 19.9914 32.5387C19.4444 33.0935 19.1406 33.794 19.1406 34.5856C19.1406 35.5944 19.626 36.4328 20.3522 37.0806Z" fill="#36CFFF"/>
    <path d="M35.3604 36.6263L34.5375 35.6748C34.5375 35.6748 35.6241 34.1752 35.6626 32.301C35.6626 30.9757 35.4063 29.9175 34.8938 29.1263C34.3814 28.3153 33.6126 27.6823 32.5877 27.2274C31.5824 26.7527 30.2323 26.367 28.5371 26.0703C27.0391 25.7933 25.9353 25.4373 25.2257 25.0021C24.5359 24.567 24.1909 23.9241 24.1909 23.0736C24.1909 22.3219 24.526 21.7186 25.1962 21.2637C25.886 20.789 26.8519 20.5516 28.0936 20.5516C28.8229 20.5516 29.6409 20.7296 30.5476 21.0857C31.474 21.4219 32.1935 21.7978 32.706 22.2131C32.9425 22.3912 33.2086 22.4802 33.5042 22.4802C33.9576 22.4802 34.3518 22.312 34.6869 21.9758C35.022 21.6197 35.1895 21.2143 35.1895 20.7593C35.1895 20.1659 34.9037 19.6417 34.3321 19.1868C33.6028 18.5736 32.6862 18.0791 31.5824 17.7033C30.4983 17.3275 29.3354 17.1396 28.0936 17.1396C26.7139 17.1396 25.4623 17.3868 24.3387 17.8813C23.2152 18.356 22.3283 19.0582 21.6778 19.9879C21.0942 20.8042 20.7724 21.7558 20.7124 22.8428H19.4746C19.5362 21.5212 19.9241 20.3174 20.6684 19.2741C21.4602 18.1446 22.534 17.3035 23.8491 16.7461C25.1457 16.177 26.567 15.9033 28.0936 15.9033C29.4607 15.9033 30.7604 16.1103 31.9841 16.5341C33.1945 16.9466 34.2488 17.5047 35.1154 18.2303C35.8992 18.8589 36.4258 19.7087 36.4258 20.7593C36.4258 21.554 36.1204 22.2565 35.5871 22.823L35.5751 22.8359L35.5626 22.8484C35.0077 23.4052 34.3031 23.7164 33.5042 23.7164C32.94 23.7164 32.4131 23.54 31.9625 23.2009L31.9448 23.1875L31.9275 23.1735C31.5608 22.8763 30.9804 22.5579 30.1258 22.2478L30.1107 22.2423L30.0958 22.2364C29.2875 21.919 28.6259 21.7879 28.0936 21.7879C26.9879 21.7879 26.3032 22.0026 25.897 22.2821L25.8938 22.2843L25.8905 22.2865C25.5282 22.5325 25.4272 22.7678 25.4272 23.0736C25.4272 23.5187 25.5706 23.7561 25.879 23.9525C26.3935 24.2659 27.3144 24.5866 28.7563 24.8536C30.4985 25.1589 31.9616 25.5667 33.1026 26.1034C34.3041 26.6392 35.2736 27.4159 35.9352 28.46C36.6172 29.5162 36.8988 30.8327 36.8988 32.301C36.8988 34.5872 35.3604 36.6263 35.3604 36.6263Z" fill="#36CFFF"/>
    </g>
    <g filter="url(#filter1_di)">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M11.7366 44.2635C20.7187 53.2455 35.2815 53.2455 44.2636 44.2635C53.2457 35.2815 53.2457 20.7187 44.2636 11.7367C35.2815 2.75471 20.7187 2.75471 11.7366 11.7367C2.75448 20.7187 2.75448 35.2815 11.7366 44.2635ZM11.0295 44.9706C20.4021 54.3431 35.5981 54.3431 44.9708 44.9706C54.3434 35.5981 54.3434 20.4022 44.9708 11.0296C35.5981 1.65708 20.4021 1.65708 11.0295 11.0296C1.65684 20.4022 1.65684 35.5981 11.0295 44.9706Z" fill="#36CFFF"/>
    </g>
    <defs>
    <filter id="filter0_di" x="15.1406" y="11.9033" width="25.7582" height="31.8349" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feOffset/>
    <feGaussianBlur stdDeviation="2"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0.759563 0 0 0 0 1 0 0 0 1 0"/>
    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feOffset dx="0.2" dy="0.2"/>
    <feGaussianBlur stdDeviation="0.5"/>
    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0.759563 0 0 0 0 1 0 0 0 1 0"/>
    <feBlend mode="normal" in2="shape" result="effect2_innerShadow"/>
    </filter>
    <filter id="filter1_di" x="0" y="0" width="56.0002" height="55.9998" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feOffset/>
    <feGaussianBlur stdDeviation="2"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0.759563 0 0 0 0 1 0 0 0 1 0"/>
    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feOffset dx="0.2" dy="0.2"/>
    <feGaussianBlur stdDeviation="0.5"/>
    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0.759563 0 0 0 0 1 0 0 0 1 0"/>
    <feBlend mode="normal" in2="shape" result="effect2_innerShadow"/>
    </filter>
    </defs>
    </svg>
    
  );
};
export const cardIcon = props => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20 4H4C2.89 4 2.01 4.89 2.01 6L2 18C2 19.11 2.89 20 4 20H20C21.11 20 22 19.11 22 18V6C22 4.89 21.11 4 20 4ZM20 18H4V12H20V18ZM20 8H4V6H20V8Z" fill="#7B81A3" />
    </svg>

  );
};
export const CopyLinkIcon = props => {
  return (
    <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15 14.08C14.24 14.08 13.56 14.38 13.04 14.85L5.91 10.7C5.96 10.47 6 10.24 6 10C6 9.76 5.96 9.53 5.91 9.3L12.96 5.19C13.5 5.69 14.21 6 15 6C16.66 6 18 4.66 18 3C18 1.34 16.66 0 15 0C13.34 0 12 1.34 12 3C12 3.24 12.04 3.47 12.09 3.7L5.04 7.81C4.5 7.31 3.79 7 3 7C1.34 7 0 8.34 0 10C0 11.66 1.34 13 3 13C3.79 13 4.5 12.69 5.04 12.19L12.16 16.35C12.11 16.56 12.08 16.78 12.08 17C12.08 18.61 13.39 19.92 15 19.92C16.61 19.92 17.92 18.61 17.92 17C17.92 15.39 16.61 14.08 15 14.08Z" fill="#D750A1"/>
</svg>

  );
};

export const GridContentIcon = props => {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3 22C1.34315 22 -1.97578e-08 20.6569 0 19L1.90798e-07 3C2.10556e-07 1.34315 1.34315 -1.97576e-08 3 0L19 1.90799e-07C20.6569 2.10556e-07 22 1.34315 22 3V19C22 20.6569 20.6569 22 19 22H3ZM2 19C2 19.5523 2.44772 20 3 20H19C19.5523 20 20 19.5523 20 19V17H2V19ZM2 15L20 15V3C20 2.44772 19.5523 2 19 2L3 2C2.44772 2 2 2.44772 2 3L2 15Z"
        fill="#797F92"
      />
    </svg>
  );
};

export const GridIcon = props => {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 3C0 1.34315 1.34315 0 3 0H19C20.6569 0 22 1.34315 22 3V19C22 20.6569 20.6569 22 19 22H3C1.34315 22 0 20.6569 0 19V3ZM3 2C2.44772 2 2 2.44772 2 3V10H10V2H3ZM12 2V10H20V3C20 2.44772 19.5523 2 19 2H12ZM20 12H12V20H19C19.5523 20 20 19.5523 20 19V12ZM10 20V12H2V19C2 19.5523 2.44772 20 3 20H10Z"
        fill="#797F92"
      />
    </svg>
  );
};

export const DeleteIcon = props => {
  return (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d)">
        <path
          d="M15 25C20.5228 25 25 20.5228 25 15C25 9.47715 20.5228 5 15 5C9.47715 5 5 9.47715 5 15C5 20.5228 9.47715 25 15 25Z"
          fill="#E7EAF3"
        />
        <path d="M18 12L12 18" stroke="#10161E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12 12L18 18" stroke="#10161E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <filter
          id="filter0_d"
          x="-2"
          y="-2"
          width="34"
          height="34"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset />
          <feGaussianBlur stdDeviation="2.5" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0862745 0 0 0 0 0.117647 0 0 0 1 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
      </defs>
    </svg>
  );
};
export const ClipIcon = props => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M15.7322 8.5788L9.7127 14.5983C8.97527 15.3357 7.9751 15.75 6.93221 15.75C5.88932 15.75 4.88915 15.3357 4.15172 14.5983C3.41429 13.8609 3 12.8607 3 11.8178C3 10.7749 3.41429 9.77473 4.15172 9.0373L10.1712 3.01781C10.6628 2.52619 11.3296 2.25 12.0249 2.25C12.7201 2.25 13.3869 2.52619 13.8785 3.01781C14.3701 3.50943 14.6463 4.17621 14.6463 4.87147C14.6463 5.56673 14.3701 6.23351 13.8785 6.72513L7.85249 12.7446C7.60668 12.9904 7.27329 13.1285 6.92566 13.1285C6.57803 13.1285 6.24464 12.9904 5.99883 12.7446C5.75302 12.4988 5.61492 12.1654 5.61492 11.8178C5.61492 11.4702 5.75302 11.1368 5.99883 10.891L11.5598 5.33653"
        stroke="#E7EAF3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const NewDeleteIcon = props => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.4099 12.0002L19.7099 5.71019C19.8982 5.52188 20.004 5.26649 20.004 5.00019C20.004 4.73388 19.8982 4.47849 19.7099 4.29019C19.5216 4.10188 19.2662 3.99609 18.9999 3.99609C18.7336 3.99609 18.4782 4.10188 18.2899 4.29019L11.9999 10.5902L5.70994 4.29019C5.52164 4.10188 5.26624 3.99609 4.99994 3.99609C4.73364 3.99609 4.47824 4.10188 4.28994 4.29019C4.10164 4.47849 3.99585 4.73388 3.99585 5.00019C3.99585 5.26649 4.10164 5.52188 4.28994 5.71019L10.5899 12.0002L4.28994 18.2902C4.19621 18.3831 4.12182 18.4937 4.07105 18.6156C4.02028 18.7375 3.99414 18.8682 3.99414 19.0002C3.99414 19.1322 4.02028 19.2629 4.07105 19.3848C4.12182 19.5066 4.19621 19.6172 4.28994 19.7102C4.3829 19.8039 4.4935 19.8783 4.61536 19.9291C4.73722 19.9798 4.86793 20.006 4.99994 20.006C5.13195 20.006 5.26266 19.9798 5.38452 19.9291C5.50638 19.8783 5.61698 19.8039 5.70994 19.7102L11.9999 13.4102L18.2899 19.7102C18.3829 19.8039 18.4935 19.8783 18.6154 19.9291C18.7372 19.9798 18.8679 20.006 18.9999 20.006C19.132 20.006 19.2627 19.9798 19.3845 19.9291C19.5064 19.8783 19.617 19.8039 19.7099 19.7102C19.8037 19.6172 19.8781 19.5066 19.9288 19.3848C19.9796 19.2629 20.0057 19.1322 20.0057 19.0002C20.0057 18.8682 19.9796 18.7375 19.9288 18.6156C19.8781 18.4937 19.8037 18.3831 19.7099 18.2902L13.4099 12.0002Z"
        fill="#E7EAF3"
      />
    </svg>
  );
};

export const LogoutSmile = props => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        stroke="#E7EAF3"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M8 15H16" stroke="#E7EAF3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M15 9H15.01" stroke="#E7EAF3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M9 9H9.01" stroke="#E7EAF3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export const MenuRightArrow = props => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M6 12L10 8L6 4" stroke="#797F92" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export const ChooseLang = props => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M4 6L8 10L12 6" stroke="#797F92" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export const SelectedIcon = props => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="12" cy="12" r="8.1" stroke="#D0D5E5" strokeWidth="1.8" />
      <path d="M15 10L11.625 15L9 12" stroke="#D0D5E5" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export const DownArrow = ({ fill = '#575E71', ...props }) => {
  return (
    <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M1 1L5 5L9 1" stroke={fill} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export const SelectCheckedCircle = props => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="12" cy="12" r="8.1" stroke="#D0D5E5" strokeWidth="1.8" />
      <path d="M15 10L11.625 15L9 12" stroke="#D0D5E5" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export const SelectUncheckedCircle = props => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="12" cy="12" r="8.1" stroke="#D0D5E5" strokeWidth="1.8" />
    </svg>
  );
};

export const CameraIconPlus = props => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M20 10.5C19.7348 10.5 19.4804 10.6054 19.2929 10.7929C19.1054 10.9804 19 11.2348 19 11.5V18.5C19 18.7652 18.8946 19.0196 18.7071 19.2071C18.5196 19.3946 18.2652 19.5 18 19.5H4C3.73478 19.5 3.48043 19.3946 3.29289 19.2071C3.10536 19.0196 3 18.7652 3 18.5V10.5C3 10.2348 3.10536 9.98043 3.29289 9.79289C3.48043 9.60536 3.73478 9.5 4 9.5H6C6.21807 9.51138 6.43386 9.45107 6.61443 9.32829C6.795 9.2055 6.93042 9.02698 7 8.82L7.54 7.18C7.60709 6.98138 7.7349 6.80887 7.90537 6.68684C8.07584 6.56482 8.28036 6.49946 8.49 6.5H14C14.2652 6.5 14.5196 6.39464 14.7071 6.20711C14.8946 6.01957 15 5.76522 15 5.5C15 5.23478 14.8946 4.98043 14.7071 4.79289C14.5196 4.60536 14.2652 4.5 14 4.5H8.44C7.81155 4.50118 7.19933 4.69968 6.68977 5.06751C6.1802 5.43533 5.79901 5.95389 5.6 6.55L5.28 7.55H4C3.20435 7.55 2.44129 7.86607 1.87868 8.42868C1.31607 8.99129 1 9.75435 1 10.55V18.55C1 19.3456 1.31607 20.1087 1.87868 20.6713C2.44129 21.2339 3.20435 21.55 4 21.55H18C18.7956 21.55 19.5587 21.2339 20.1213 20.6713C20.6839 20.1087 21 19.3456 21 18.55V11.55C21.0068 11.4145 20.9859 11.2791 20.9387 11.1519C20.8915 11.0248 20.8189 10.9086 20.7254 10.8103C20.6318 10.7121 20.5193 10.634 20.3946 10.5806C20.2699 10.5273 20.1356 10.4998 20 10.5ZM11 9.5C10.2089 9.5 9.43552 9.7346 8.77772 10.1741C8.11992 10.6136 7.60723 11.2384 7.30448 11.9693C7.00173 12.7002 6.92252 13.5044 7.07686 14.2804C7.2312 15.0563 7.61216 15.769 8.17157 16.3284C8.73098 16.8878 9.44372 17.2688 10.2196 17.4231C10.9956 17.5775 11.7998 17.4983 12.5307 17.1955C13.2616 16.8928 13.8864 16.3801 14.3259 15.7223C14.7654 15.0645 15 14.2911 15 13.5C15 12.4391 14.5786 11.4217 13.8284 10.6716C13.0783 9.92143 12.0609 9.5 11 9.5ZM11 15.5C10.6044 15.5 10.2178 15.3827 9.88886 15.1629C9.55996 14.9432 9.30362 14.6308 9.15224 14.2654C9.00087 13.8999 8.96126 13.4978 9.03843 13.1098C9.1156 12.7219 9.30608 12.3655 9.58579 12.0858C9.86549 11.8061 10.2219 11.6156 10.6098 11.5384C10.9978 11.4613 11.3999 11.5009 11.7654 11.6522C12.1308 11.8036 12.4432 12.06 12.6629 12.3889C12.8827 12.7178 13 13.1044 13 13.5C13 14.0304 12.7893 14.5391 12.4142 14.9142C12.0391 15.2893 11.5304 15.5 11 15.5ZM22 4.5H21V3.5C21 3.23478 20.8946 2.98043 20.7071 2.79289C20.5196 2.60536 20.2652 2.5 20 2.5C19.7348 2.5 19.4804 2.60536 19.2929 2.79289C19.1054 2.98043 19 3.23478 19 3.5V4.5H18C17.7348 4.5 17.4804 4.60536 17.2929 4.79289C17.1054 4.98043 17 5.23478 17 5.5C17 5.76522 17.1054 6.01957 17.2929 6.20711C17.4804 6.39464 17.7348 6.5 18 6.5H19V7.5C19 7.76522 19.1054 8.01957 19.2929 8.20711C19.4804 8.39464 19.7348 8.5 20 8.5C20.2652 8.5 20.5196 8.39464 20.7071 8.20711C20.8946 8.01957 21 7.76522 21 7.5V6.5H22C22.2652 6.5 22.5196 6.39464 22.7071 6.20711C22.8946 6.01957 23 5.76522 23 5.5C23 5.23478 22.8946 4.98043 22.7071 4.79289C22.5196 4.60536 22.2652 4.5 22 4.5Z"
        fill="#E7EAF3"
      />
    </svg>
  );
};

export const PostShareIcon = props => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M17 6L7 12L17 18" stroke="#E7EAF3" strokeWidth="1.5" />
      <path
        d="M20.25 6.00002C20.25 7.24267 19.2426 8.25002 18 8.25002C16.7574 8.25002 15.75 7.24267 15.75 6.00002C15.75 4.75738 16.7574 3.75002 18 3.75002C19.2426 3.75002 20.25 4.75738 20.25 6.00002Z"
        fill="#10161E"
        stroke="#E7EAF3"
        strokeWidth="1.5"
      />
      <circle cx="6" cy="12" r="2.25" fill="#10161E" stroke="#E7EAF3" strokeWidth="1.5" />
      <circle cx="18" cy="18.0415" r="2.25" fill="#10161E" stroke="#E7EAF3" strokeWidth="1.5" />
    </svg>
  );
};

export const WelcomeIcon = props => {
  return (
    <svg width="122" height="122" viewBox="0 0 122 122" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_ddd)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M61 92C78.1208 92 92 78.1208 92 61C92 43.8792 78.1208 30 61 30C43.8792 30 30 43.8792 30 61C30 78.1208 43.8792 92 61 92ZM55.1938 79.4722C57.1713 80.0725 59.396 80.3727 61.8679 80.3727C64.2692 80.3727 66.4939 79.9313 68.5421 79.0485C70.6255 78.1656 72.3029 76.8944 73.5741 75.2347C74.8454 73.575 75.481 71.5975 75.481 69.3021C75.481 67.5012 75.2162 65.9827 74.6865 64.7468C74.1568 63.4755 73.3622 62.4338 72.3029 61.6216C71.2435 60.7741 69.9016 60.0855 68.2772 59.5558C66.6881 59.0261 64.8342 58.567 62.7154 58.1786C61.0911 57.8608 59.6962 57.5077 58.5309 57.1192C57.3656 56.6955 56.4651 56.1481 55.8294 55.4772C55.2291 54.7709 54.929 53.8881 54.929 52.8287C54.929 51.9459 55.1938 51.169 55.7235 50.4981C56.2532 49.8271 57.0301 49.2974 58.0542 48.909C59.1135 48.5206 60.4025 48.3263 61.9209 48.3263C62.839 48.3263 63.8278 48.4852 64.8872 48.8031C65.9466 49.0856 66.953 49.4564 67.9064 49.9154C68.8599 50.3392 69.6191 50.7982 70.1841 51.2926C70.6079 51.6104 71.0846 51.7693 71.6143 51.7693C72.4265 51.7693 73.1327 51.4515 73.733 50.8159C74.3333 50.1803 74.6335 49.474 74.6335 48.6971C74.6335 47.6377 74.1215 46.702 73.0974 45.8898C71.8615 44.8304 70.2547 43.9652 68.2772 43.2943C66.335 42.588 64.2162 42.2349 61.9209 42.2349C59.4843 42.2349 57.2596 42.6586 55.2468 43.5061C53.234 44.3537 51.6272 45.5896 50.4266 47.214C49.2613 48.8384 48.6786 50.7982 48.6786 53.0936C48.6786 54.612 48.9258 55.9892 49.4202 57.2252C49.9146 58.4258 50.6385 59.4852 51.5919 60.4033C52.5807 61.2861 53.799 62.0277 55.2468 62.628C56.6946 63.193 58.372 63.6168 60.2789 63.8993C62.2917 64.1818 63.9514 64.5879 65.258 65.1176C66.5645 65.6119 67.5356 66.2299 68.1713 66.9715C68.8069 67.7131 69.1247 68.6135 69.1247 69.6729C69.1247 70.5557 68.7892 71.3503 68.1183 72.0565C67.4474 72.7275 66.5645 73.2748 65.4698 73.6986C64.3751 74.087 63.1745 74.2812 61.8679 74.2812C59.9257 74.2812 58.2837 73.9987 56.9418 73.4337C55.6352 72.8687 54.311 72.0389 52.9691 70.9442C52.4394 70.5204 51.8391 70.3086 51.1682 70.3086C50.2853 70.3086 49.5438 70.6264 48.9435 71.262C48.3785 71.8623 48.0959 72.5686 48.0959 73.3808C48.0959 73.8751 48.2195 74.3695 48.4667 74.8639C48.7139 75.3583 49.067 75.7997 49.5261 76.1881C51.3271 77.7419 53.2163 78.8366 55.1938 79.4722Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_ddd"
          x="0"
          y="0"
          width="122"
          height="122"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset />
          <feGaussianBlur stdDeviation="15" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.1125 0 0 0 0 0.84025 0 0 0 0 1 0 0 0 0.8 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.204167 0 0 0 0 0.681667 0 0 0 0.61 0" />
          <feBlend mode="normal" in2="effect1_dropShadow" result="effect2_dropShadow" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="-2" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.00784314 0 0 0 0 1 0 0 0 0 0.760784 0 0 0 0.88 0" />
          <feBlend mode="normal" in2="effect2_dropShadow" result="effect3_dropShadow" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect3_dropShadow" result="shape" />
        </filter>
      </defs>
    </svg>
  );
};
export const DotIcon = props => {
  return (
    <svg width="3" height="3" viewBox="0 0 3 3" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="1.5" cy="1.5" r="1.5" fill="#E7EAF3" />
    </svg>
  );
};
export const CanselIcon = props => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.4099 11.9999L19.7099 5.70994C19.8982 5.52164 20.004 5.26624 20.004 4.99994C20.004 4.73364 19.8982 4.47825 19.7099 4.28994C19.5216 4.10164 19.2662 3.99585 18.9999 3.99585C18.7336 3.99585 18.4782 4.10164 18.2899 4.28994L11.9999 10.5899L5.70994 4.28994C5.52164 4.10164 5.26624 3.99585 4.99994 3.99585C4.73364 3.99585 4.47824 4.10164 4.28994 4.28994C4.10164 4.47825 3.99585 4.73364 3.99585 4.99994C3.99585 5.26624 4.10164 5.52164 4.28994 5.70994L10.5899 11.9999L4.28994 18.2899C4.19621 18.3829 4.12182 18.4935 4.07105 18.6154C4.02028 18.7372 3.99414 18.8679 3.99414 18.9999C3.99414 19.132 4.02028 19.2627 4.07105 19.3845C4.12182 19.5064 4.19621 19.617 4.28994 19.7099C4.3829 19.8037 4.4935 19.8781 4.61536 19.9288C4.73722 19.9796 4.86793 20.0057 4.99994 20.0057C5.13195 20.0057 5.26266 19.9796 5.38452 19.9288C5.50638 19.8781 5.61698 19.8037 5.70994 19.7099L11.9999 13.4099L18.2899 19.7099C18.3829 19.8037 18.4935 19.8781 18.6154 19.9288C18.7372 19.9796 18.8679 20.0057 18.9999 20.0057C19.132 20.0057 19.2627 19.9796 19.3845 19.9288C19.5064 19.8781 19.617 19.8037 19.7099 19.7099C19.8037 19.617 19.8781 19.5064 19.9288 19.3845C19.9796 19.2627 20.0057 19.132 20.0057 18.9999C20.0057 18.8679 19.9796 18.7372 19.9288 18.6154C19.8781 18.4935 19.8037 18.3829 19.7099 18.2899L13.4099 11.9999Z" fill="#E7EAF3"/>
    </svg>
    
  );
};
export const PaymentCkeckmark = props => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.00003 16.17L4.83003 12L3.41003 13.41L9.00003 19L21 6.99997L19.59 5.58997L9.00003 16.17Z" fill="#36CFFF"/>
</svg>

    
  );
};
export const CardFail = props => {
  return (
    <svg width="55" height="55" viewBox="0 0 55 55" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="27.5" cy="27.5" r="26.5" stroke="#FF496B" stroke-width="2"/>
    <path d="M16 28C16 30.2091 14.2091 32 12 32C9.79086 32 8 30.2091 8 28" stroke="#FF496B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M46 28C46 30.2091 44.2091 32 42 32C39.7909 32 38 30.2091 38 28" stroke="#FF496B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M33 41C33 41 31.1667 38 27.5 38C23.8333 38 22 41 22 41" stroke="#FF496B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    
    
  );
};

export const StatisticsIcon = props => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="17.25"
        y="4.25"
        width="3.5"
        height="15.5"
        stroke="#E7EAF3"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <rect
        x="10.25"
        y="8.25"
        width="3.5"
        height="11.5"
        stroke="#E7EAF3"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <rect
        x="3.25"
        y="11.25"
        width="3.5"
        height="8.5"
        stroke="#E7EAF3"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const SendCommentFilledIcon = props => {
  return (
    <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M1.9 17.4L19.35 9.92002C20.16 9.57002 20.16 8.43002 19.35 8.08002L1.9 0.600017C1.24 0.310017 0.51 0.800017 0.51 1.51002L0.5 6.12002C0.5 6.62002 0.87 7.05002 1.37 7.11002L15.5 9.00002L1.37 10.88C0.87 10.95 0.5 11.38 0.5 11.88L0.51 16.49C0.51 17.2 1.24 17.69 1.9 17.4V17.4Z" fill="#D750A1"/>
    </svg>
    
  );
};


export const SendCommentIcon = props => {
  return (
    <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
<path d="M1.9 17.4L19.35 9.92002C20.16 9.57002 20.16 8.43002 19.35 8.08002L1.9 0.600017C1.24 0.310017 0.51 0.800017 0.51 1.51002L0.5 6.12002C0.5 6.62002 0.87 7.05002 1.37 7.11002L15.5 9.00002L1.37 10.88C0.87 10.95 0.5 11.38 0.5 11.88L0.51 16.49C0.51 17.2 1.24 17.69 1.9 17.4Z" fill="#3D4052"/>
</svg>


    
  );
};

export const CloseModalIcon = ({ fill = '#10161E', ...props }) => {
  return (
  
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.59 0L5 3.59L1.41 0L0 1.41L3.59 5L0 8.59L1.41 10L5 6.41L8.59 10L10 8.59L6.41 5L10 1.41L8.59 0Z"    fill={fill}/>
    </svg>
    
  );
};

export const DeleteBlackIcon = props => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z"
        fill="#10161E"
        stroke="#E7EAF3"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M15 9L9 15" stroke="#E7EAF3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M9 9L15 15" stroke="#E7EAF3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export const SearchIconGray = props => {
  return (
    <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.8139 12.8197L11.2165 10.2433C12.2247 8.9862 12.713 7.39056 12.5809 5.78449C12.4488 4.17843 11.7063 2.68402 10.5062 1.60855C9.30612 0.533073 7.73957 -0.0417195 6.12869 0.00236006C4.5178 0.0464396 2.98503 0.70604 1.84553 1.84553C0.70604 2.98503 0.0464396 4.5178 0.00236006 6.12869C-0.0417195 7.73957 0.533073 9.30612 1.60855 10.5062C2.68402 11.7063 4.17843 12.4488 5.78449 12.5809C7.39056 12.713 8.9862 12.2247 10.2433 11.2165L12.8197 13.7929C12.8848 13.8585 12.9623 13.9106 13.0476 13.9462C13.1329 13.9817 13.2244 14 13.3168 14C13.4093 14 13.5008 13.9817 13.5861 13.9462C13.6714 13.9106 13.7488 13.8585 13.8139 13.7929C13.9401 13.6624 14.0106 13.4879 14.0106 13.3063C14.0106 13.1248 13.9401 12.9503 13.8139 12.8197ZM6.31567 11.2165C5.34638 11.2165 4.39886 10.9291 3.59293 10.3905C2.787 9.85204 2.15885 9.08664 1.78792 8.19113C1.41699 7.29563 1.31993 6.31024 1.50903 5.35957C1.69813 4.40891 2.16489 3.53567 2.85028 2.85028C3.53567 2.16489 4.40891 1.69813 5.35957 1.50903C6.31024 1.31993 7.29563 1.41699 8.19113 1.78792C9.08664 2.15885 9.85204 2.787 10.3905 3.59293C10.9291 4.39886 11.2165 5.34638 11.2165 6.31567C11.2165 7.61545 10.7001 8.86199 9.78107 9.78107C8.86199 10.7001 7.61545 11.2165 6.31567 11.2165Z"
        fill="#8B95B1"
      />
    </svg>
  );
};

export const ClearSearchIcon = props => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M13.2337 11.9993L18.7428 6.4989C18.9075 6.33424 19 6.11091 19 5.87804C19 5.64517 18.9075 5.42184 18.7428 5.25717C18.5782 5.09251 18.3548 5 18.122 5C17.8891 5 17.6658 5.09251 17.5011 5.25717L12.0007 10.7663L6.5004 5.25717C6.33573 5.09251 6.1124 5 5.87953 5C5.64666 5 5.42333 5.09251 5.25866 5.25717C5.094 5.42184 5.00149 5.64517 5.00149 5.87804C5.00149 6.11091 5.094 6.33424 5.25866 6.4989L10.7678 11.9993L5.25866 17.4996C5.1767 17.5809 5.11165 17.6776 5.06725 17.7842C5.02286 17.8907 5 18.005 5 18.1205C5 18.2359 5.02286 18.3502 5.06725 18.4568C5.11165 18.5633 5.1767 18.66 5.25866 18.7413C5.33996 18.8233 5.43667 18.8884 5.54323 18.9327C5.64979 18.9771 5.76409 19 5.87953 19C5.99497 19 6.10927 18.9771 6.21583 18.9327C6.32239 18.8884 6.4191 18.8233 6.5004 18.7413L12.0007 13.2322L17.5011 18.7413C17.5824 18.8233 17.6791 18.8884 17.7857 18.9327C17.8922 18.9771 18.0065 19 18.122 19C18.2374 19 18.3517 18.9771 18.4583 18.9327C18.5648 18.8884 18.6615 18.8233 18.7428 18.7413C18.8248 18.66 18.8898 18.5633 18.9342 18.4568C18.9786 18.3502 19.0015 18.2359 19.0015 18.1205C19.0015 18.005 18.9786 17.8907 18.9342 17.7842C18.8898 17.6776 18.8248 17.5809 18.7428 17.4996L13.2337 11.9993Z"
        fill="#797F92"
      />
    </svg>
  );
};

export const UserVerifiedBadge = props => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M14.473 7.52667L12.9063 6V3.76C12.9063 3.58319 12.8361 3.41362 12.711 3.2886C12.586 3.16357 12.4164 3.09333 12.2396 3.09333H10.033L8.47297 1.52667C8.41099 1.46418 8.33726 1.41458 8.25602 1.38074C8.17478 1.34689 8.08764 1.32947 7.99963 1.32947C7.91163 1.32947 7.82449 1.34689 7.74325 1.38074C7.66201 1.41458 7.58828 1.46418 7.5263 1.52667L5.99963 3.09333H3.75963C3.58282 3.09333 3.41325 3.16357 3.28823 3.2886C3.16321 3.41362 3.09297 3.58319 3.09297 3.76V6L1.5263 7.52667C1.46381 7.58864 1.41422 7.66238 1.38037 7.74362C1.34653 7.82486 1.3291 7.91199 1.3291 8C1.3291 8.08801 1.34653 8.17515 1.38037 8.25638C1.41422 8.33762 1.46381 8.41136 1.5263 8.47333L3.09297 10.0333V12.24C3.09297 12.4168 3.16321 12.5864 3.28823 12.7114C3.41325 12.8364 3.58282 12.9067 3.75963 12.9067H5.99963L7.55963 14.4733C7.62161 14.5358 7.69534 14.5854 7.77658 14.6193C7.85782 14.6531 7.94496 14.6705 8.03297 14.6705C8.12098 14.6705 8.20811 14.6531 8.28935 14.6193C8.37059 14.5854 8.44433 14.5358 8.5063 14.4733L10.0663 12.9067H12.273C12.4498 12.9067 12.6193 12.8364 12.7444 12.7114C12.8694 12.5864 12.9396 12.4168 12.9396 12.24V10.0333L14.5063 8.47333C14.5667 8.40918 14.6137 8.33371 14.6447 8.25128C14.6757 8.16884 14.6901 8.08107 14.687 7.99305C14.6839 7.90503 14.6634 7.81849 14.6267 7.73844C14.5899 7.65839 14.5377 7.58641 14.473 7.52667ZM11.773 9.28667C11.71 9.34841 11.6599 9.42204 11.6255 9.50329C11.5912 9.58454 11.5733 9.6718 11.573 9.76V11.5733H9.75963C9.67143 11.5737 9.58417 11.5916 9.50292 11.6259C9.42167 11.6602 9.34804 11.7103 9.2863 11.7733L7.99963 13.06L6.71297 11.7733C6.65122 11.7103 6.57759 11.6602 6.49634 11.6259C6.41509 11.5916 6.32784 11.5737 6.23963 11.5733H4.4263V9.76C4.42593 9.6718 4.40807 9.58454 4.37374 9.50329C4.33941 9.42204 4.28929 9.34841 4.2263 9.28667L2.93963 8L4.2263 6.71333C4.28929 6.65159 4.33941 6.57796 4.37374 6.49671C4.40807 6.41546 4.42593 6.3282 4.4263 6.24V4.42667H6.23963C6.32784 4.4263 6.41509 4.40843 6.49634 4.3741C6.57759 4.33977 6.65122 4.28966 6.71297 4.22667L7.99963 2.94L9.2863 4.22667C9.34804 4.28966 9.42167 4.33977 9.50292 4.3741C9.58417 4.40843 9.67143 4.4263 9.75963 4.42667H11.573V6.24C11.5733 6.3282 11.5912 6.41546 11.6255 6.49671C11.6599 6.57796 11.71 6.65159 11.773 6.71333L13.0596 8L11.773 9.28667Z"
        fill="#DFE3EE"
      />
      <path
        d="M6.22266 7.55559L8.00043 9.33336L13.4549 4.36365"
        stroke="#DFE3EE"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const ProfilePostIcon = props => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect x="3.75" y="3.75" width="16.5" height="16.5" rx="1.25" stroke="#E7EAF3" strokeWidth="1.5" />
      <line
        x1="7.75"
        y1="9.25"
        x2="12.25"
        y2="9.25"
        stroke="#E7EAF3"
        stroke-width="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="7.75"
        y1="14.25"
        x2="16.25"
        y2="14.25"
        stroke="#E7EAF3"
        stroke-width="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ProfilePhotoIcons = props => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect x="3.75" y="3.75" width="16.5" height="16.5" rx="1.25" stroke="#E7EAF3" stroke-width="1.5" />
      <path
        d="M4 19.913L9 12.5L17 19.913"
        stroke="#E7EAF3"
        stroke-width="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="14.5" cy="9.5" r="1.75" stroke="#E7EAF3" stroke-width="1.5" />
    </svg>
  );
};

export const ProfileVideoIcons = props => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect x="2.75" y="4.75" width="13.5" height="14.5" rx="1.25" stroke="#E7EAF3" stroke-width="1.5" />
      <path d="M16 11L22 7V17L16 14" stroke="#E7EAF3" stroke-width="1.5" strokeLinejoin="round" />
    </svg>
  );
};

export const ProfileSavePostIcon = props => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M18 19.5L12 15.3333L6 19.5V6.16667C6 5.72464 6.18061 5.30072 6.5021 4.98816C6.82359 4.67559 7.25963 4.5 7.71429 4.5H16.2857C16.7404 4.5 17.1764 4.67559 17.4979 4.98816C17.8194 5.30072 18 5.72464 18 6.16667V19.5Z"
        stroke="#E7EAF3"
        stroke-width="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ProfileStatisticIcon = props => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect
        x="17.25"
        y="4.25"
        width="3.5"
        height="15.5"
        stroke="#E7EAF3"
        stroke-width="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="10.25"
        y="8.25"
        width="3.5"
        height="11.5"
        stroke="#E7EAF3"
        stroke-width="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="3.25"
        y="11.25"
        width="3.5"
        height="8.5"
        stroke="#E7EAF3"
        stroke-width="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
